/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = parseInt(clmVars.breakpoints.mobile_max);
 const navBreakpoint = parseInt(clmVars.breakpoints.mobile_navigation_max);
 const windowResizeActions = [];
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

 /*
  * Viewport height adjustments
  ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
function setVh() {
  const vv = window.visualViewport;
  const height = vv ? vv.height : window.innerHeight;
  document.documentElement.style.setProperty('--vh', `${height * 0.01}px`);
}

setVh();

window.addEventListener('resize', setVh);
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', setVh);
  window.visualViewport.addEventListener('scroll', setVh);
}

/*
 * Globals
 ***************************/
  /* Window */
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    let windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    let isMobile = ( windowWidth <= mobileBreakpoint );
    let isMobileChatActive = ( windowWidth <= navBreakpoint );
  /* Navigation */
    let isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Ajax */
    let currentPage = 1;
    let ajaxIsLoading = false;
    let isDoneLoadingThings = false;
    let currentUrl = window.location.href;

  /* Slick Options */
    const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
    const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

$(document).ready(function(){
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  gsap.registerPlugin(ScrollTrigger, Flip, ScrollSmoother);

  const isTouch = window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window;
  if ( !isTouch ) {
    smooth = ScrollSmoother.create({
      smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
      touchSmooth: false,
      effects: true, // looks for data-speed and data-lag attributes on elements
      normalizeScroll: true,
    });

    $('body').addClass('has-smooth-scroll');
    const chat = $('.site-messages');
    const header = $('.site-header');

    $('.site-messages__messages').on('mousewheel', function(e){
      e.stopPropagation();
    });

    $('.site-messages__messages').on('scroll', function(e){
      e.stopPropagation();
    });

    ScrollTrigger.matchMedia({
      '(min-width:768px)': function() {
        ScrollTrigger.create({
          trigger: '#page',
          endTrigger: '.site-footer',
          start: 'top top',
          end: 'top bottom',
          pin: chat.get(0),
          pinSpacing: false,
          pinType: 'transform'
        })

        ScrollTrigger.create({
          trigger: '#page',
          start: 'top top',
          end: 'bottom top',
          pin: header.get(0),
          pinSpacing: false,
          pinType: 'transform'
        });
      },
      '(max-width:767px)': function() {
        ScrollTrigger.create({
          trigger: '#page',
          start: 'top top',
          end: 'bottom top',
          pin: header.get(0),
          pinSpacing: false,
          pinType: 'transform'
        });

        ScrollTrigger.create({
          trigger: '#page',
          start: 'top top',
          end: 'bottom top',
          pin: chat.get(0),
          pinSpacing: false,
          pinType: 'transform'
        });
      }
    })
  } else {
    // For touch devices, ensure smooth wrapper elements don't interfere with touch scrolling
    $('#smooth-wrapper, #smooth-content').css({
      'touch-action': 'auto',
      'pointer-events': 'none'
    });
    $('body').removeClass('has-smooth-scroll');
  }

  /* Generic */
  if ( $('.modal-area').length ) {
    $('.modal-area').each(function(){
      const prop = $(this).data('propid');

      $(this).find('.modal-area__dismiss').on('click', function(){
        $(this).closest('.modal-area').removeClass('active');
        window.localStorage.setItem( prop, 'true' );
      }).on('keypress', handleKeypressADA);

      const element = $(this).get(0);

      $(this).on('click', function(e){
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass('active');
          window.localStorage.setItem( prop, 'true' );
        }
      });

      const modalDismissed = window.localStorage.getItem( prop );
      if ( modalDismissed != 'true' ) {
        const modal = $(this);
        setTimeout(function(){
          modal.addClass('active');
        }, $(this).data('delay'));
      }
    });
  }

  if ( $('.smooth-scroller').length ) { // internal links, smooth scrolling
    $('.smooth-scroller').on('click', function(e){
      e.preventDefault();
      let target = $( $(this).attr('href') ).offset().top - 148;
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)));
    });
  }

  if ( $('.copybutton').length ) {
    $('.copybutton').on('click', function(e){
      e.preventDefault();
      const targetEl = $( $(this).data('target') ).get(0);
      const alertEl = $( $(this).data('alert') ).get(0);
      targetEl.select()
      targetEl.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      $(alertEl).fadeIn();
      setTimeout(function(){
        $(alertEl).fadeOut();
      }, 6000);
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modaltrigger').length ) {
    $('.modaltrigger').on('click', function(e){
      e.preventDefault();
      $(this).addClass('active');
      $(this).attr('aria-expanded', true );
      $($(this).attr('href')).addClass('active');
      $('#masthead').removeClass('scrolled-back');
      $('#masthead').addClass('scrolled');
      $('body').addClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modalclose').length ) {
    $('.modalclose').on('click', function(e){
      e.preventDefault();
      const controlledBy = $(this).data('controlledby');
      $(this).closest('.modal').removeClass('active');
      $(controlledBy).removeClass('active');
      $(controlledBy).attr('aria-expanded', false);
      $('body').removeClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* NAVIGATION SCRIPTS */
  if ( $('.site-messages').length ) {
    const chatContainer = $('#site-messages');
    const mobileChatDismiss = $('.site-messages__mobile-dismiss');
    const mobileChatTrigger = $('.site-messages__mobile-trigger');
    const mobileOverlay = $('.site-messages__mobile-overlay');
    
    const firstFocusableMenuElement = $(chatContainer).find('a, button, input').eq(0).get(0);
    const lastFocusableMenuElement = mobileChatDismiss.get(0);

    const navResizeAction = (updated) => {
      if ( updated ) {
        if ( isMobile ) {
          $(chatContainer).attr('role', 'dialog');
          $(chatContainer).attr('aria-modal', 'true');
        } else {
          const chatEl = $(chatContainer).get(0);
          chatEl.removeAttribute('role');
          chatEl.removeAttribute('aria-modal');
        }
      }
    }
    windowResizeActions.push(navResizeAction);

    // Function to sync overlay visibility with chat visibility on mobile
    const syncOverlayVisibility = function() {
      if ( isMobile ) {
        const chatVisible = $(chatContainer).css('visibility') === 'visible';
        const chatHasPointerEvents = $(chatContainer).css('pointer-events') === 'auto';
        
        if ( chatVisible && chatHasPointerEvents ) {
          mobileOverlay.addClass('active');
        } else {
          mobileOverlay.removeClass('active');
        }
      }
    };

    // Handle links with #site-messages href (use event delegation for dynamic content)
    $(document).on('click', 'a[href="#site-messages"]', function(e){
      e.preventDefault();
      
      if ( isMobile ) {
        mobileChatTrigger.click();
      } else {
        chatContainer.focus();
      }
    }).on('keypress', 'a[href="#site-messages"]', handleKeypressADA);
    
    // Handle WordPress block buttons with "Find My Lawyer Now" text
    $(document).on('click', '.wp-block-button__link, .wp-element-button', function(e) {
      const buttonText = $(this).text().trim().toLowerCase();
      
      if (buttonText.includes('find my lawyer now') || buttonText.includes('find lawyer now')) {
        e.preventDefault();
        
        if ( isMobile ) {
          // Force chat open instead of toggling
          if (!mobileChatTrigger.hasClass('active')) {
            mobileChatTrigger.addClass('active');
          }
          if ( isMobileChatActive ) {
            $('body').addClass('no-scroll');
          }
          $(chatContainer).css({
            'visibility': 'visible',
            'pointer-events': 'auto',
            'display': 'block'
          });
          // Sync overlay visibility
          syncOverlayVisibility();
          
          gsap.to(chatContainer, {
            duration: 0.8,
            ease: 'power3.inOut',
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
            onComplete: function(){
              $(chatContainer).focus();
              
              // Clear any existing selected states from question buttons when chat animation completes
              const clearButtonStates = () => {
                const existingButtons = document.querySelectorAll('.chat-option-btn-inline:not(.disabled)');
                existingButtons.forEach(btn => {
                  btn.blur();
                  btn.style.backgroundColor = 'transparent';
                  btn.style.borderColor = '';
                  btn.style.outline = 'none';
                  btn.classList.remove('selected');
                });
              };
              
              // Run immediately and then again after a short delay to catch any states applied by focus
              clearButtonStates();
              setTimeout(clearButtonStates, 50);
              setTimeout(clearButtonStates, 100);
            }
          });
        } else {
          chatContainer.focus();
        }
      }
    });

    mobileChatTrigger.on('click', function(){
      $(this).toggleClass('active');
      
      if ( $(this).hasClass('active') ) {
        if ( isMobileChatActive ) {
          $('body').addClass('no-scroll');
          // Prevent background interaction when chat is open on mobile
          // document.body.style.position = 'fixed';
          // document.body.style.top = '0';
          // document.body.style.left = '0';
          // document.body.style.width = '100%';
          // document.body.style.overflow = 'hidden';

        }
        $(chatContainer).css({
          'visibility': 'visible',
          'pointer-events': 'auto',
          'display': 'block'
        });
        $('.site-main').css({
          'opacity': '0',
        });
        // Sync overlay visibility
        syncOverlayVisibility();
        
        gsap.to(chatContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          onComplete: function(){
            $(chatContainer).focus();
            
            // Clear any existing selected states from question buttons when chat animation completes
            const clearButtonStates = () => {
              const existingButtons = document.querySelectorAll('.chat-option-btn-inline:not(.disabled)');
              existingButtons.forEach(btn => {
                btn.blur();
                btn.style.backgroundColor = 'transparent';
                btn.style.borderColor = '';
                btn.style.outline = 'none';
                btn.classList.remove('selected');
              });
            };
            
            // Run immediately and then again after a short delay to catch any states applied by focus
            clearButtonStates();
            setTimeout(clearButtonStates, 50);
            setTimeout(clearButtonStates, 100);
          }
        });
      } else {
        if ( isMobileChatActive ) {
          $('body').removeClass('no-scroll');
          // Restore background interaction when chat is closed
          // document.body.style.position = '';
          // document.body.style.top = '';
          // document.body.style.left = '';
          // document.body.style.width = '';
          // document.body.style.overflow = '';
        }
        gsap.to(chatContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $(chatContainer).css({
              'visibility': 'hidden',
              'pointer-events': 'none',
              'display': 'none'
            });
            // Sync overlay visibility after chat is hidden
            syncOverlayVisibility();
            $('.site-main').css({
              'opacity': '1',
            });
          }
        });
      }
    }).on('keypress', handleKeypressADA);

    $(mobileChatDismiss).on('click', function(){
      if ( isMobileChatActive ) {
        $('body').removeClass('no-scroll');
        // Restore background interaction when chat is dismissed
        // document.body.style.position = '';
        // document.body.style.top = '';
        // document.body.style.left = '';
        // document.body.style.width = '';
        // document.body.style.overflow = '';
        
        gsap.to(chatContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $(chatContainer).css({
              'visibility': 'hidden',
              'pointer-events': 'none',
              'display': 'none'
            });
            // Sync overlay visibility after chat is hidden
            syncOverlayVisibility();
          }
        });

        $(mobileToggle).removeClass('active');
        $(mobileToggle).focus();
      }
    }).on('keypress', handleKeypressADA);

    $(chatContainer).on('keydown', function(e){
      if ( isMobileChatActive ) {
        if ( e.key == 'Escape' ) {
          mobileChatDismiss.click();
        } else if(e.target == firstFocusableMenuElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableMenuElement.focus();
        } else if(e.target == lastFocusableMenuElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableMenuElement.focus();
        }
      }
    });

    // Keyboard detection for mobile border fix
    if ( window.visualViewport && isMobile ) {
      let initialHeight = window.innerHeight;
      let keyboardTimeout;
      
      const handleKeyboardToggle = function() {
        const vvHeight = window.visualViewport.height;
        const keyboardHeight = initialHeight - vvHeight;
        const chatBody = $('.site-messages__body');
        
        clearTimeout(keyboardTimeout);
        
        if ( keyboardHeight > 100 ) {
          // Keyboard is active - remove bottom border
          chatBody.addClass('keyboard-active');
        } else {
          // Keyboard is dismissed - restore bottom border with delay
          keyboardTimeout = setTimeout(function() {
            chatBody.removeClass('keyboard-active');
          }, 150);
        }
      };
      
      // Store initial height when chat opens
      mobileChatTrigger.on('click', function() {
        if ( $(this).hasClass('active') ) {
          initialHeight = window.innerHeight;
        }
      });
      
      // Listen for visual viewport changes
      window.visualViewport.addEventListener('resize', handleKeyboardToggle);
      
      // Initial sync of overlay visibility
      syncOverlayVisibility();
      
      // Sync overlay on window resize
      window.addEventListener('resize', syncOverlayVisibility);
    }
  }
  /* END NAVIGATION SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  const animatedText = $(this).find('.acf-innerblocks-container, .wp-block-group, .wp-block-column, .content-container').not('.dont-animate-children').not('.icon-box__box').children().not('.dont-animate').not('ul').not('ol');
  animatedText.each(function(){
    const thisRef = this;

    gsap.set(this, {
      opacity: 0,
      y: 24,
    });
    
    let st = ScrollTrigger.create({
       trigger: this,
       start: 'top bottom-=80',
       end: 'bottom top',
       onEnter: function() {
         gsap.to(thisRef, {
           y: 0,
           opacity: 1
         });
       }
     });

     let revertSt = ScrollTrigger.create({
      trigger: this,
       start: 'top bottom+=24',
       end: 'bottom top',
       onLeaveBack: function() {
        gsap.set(thisRef, {
          opacity: 0,
          y: 24,
        })
       }
     })
  });

  const animatedLists = $(this).find('.acf-innerblocks-container, .wp-block-group, .wp-block-column, .content-container').not('.dont-animate-children').children().not('.dont-animate').filter('ul, ol');
  if ( animatedLists.length ) {
    animatedLists.each(function(){
      const thisRef = this;
      const lis = $(this).find('li');

      gsap.set(lis, {
        opacity: 0,
        y: 24,
      });

      let st = ScrollTrigger.create({
       trigger: this,
       start: 'top bottom-=80',
       end: 'bottom top',
       onEnter: function() {
         gsap.to(lis, {
           y: 0,
           opacity: 1,
           stagger: 0.1
         });
       }
     });

     let revertSt = ScrollTrigger.create({
      trigger: this,
       start: 'top bottom+=24',
       end: 'bottom top',
       onLeaveBack: function() {
        gsap.set(lis, {
          opacity: 0,
          y: 24,
        })
       }
     })
    });
  }

  if ( $('.image-and-text').length ) {
    $('.image-and-text').each(function(){
      const img = $(this).find('.image-and-text__image').get(0);

      gsap.set(img, {
        y: 32,
        scale: 0.8,
        opacity: 0
      });

      let st = ScrollTrigger.create({
       trigger: img,
       start: 'top bottom-=80',
       end: 'bottom top',
       onEnter: function() {
         gsap.to(img, {
           y: 0,
           scale: 1,
           opacity: 1
         });
       }
     });

     let revertSt = ScrollTrigger.create({
      trigger: img,
       start: 'top bottom+=24',
       end: 'bottom top',
       onLeaveBack: function() {
        gsap.set(img, {
          opacity: 0,
          scale: 0.8,
          y: 24,
        })
       }
     })
    });
  }

  if ( $('.icon-boxes').length ) {
    $('.icon-boxes').each(function(){
      const boxes = $(this).find('.icon-box__box');
      const icons = $(this).find('.icon-box__icon');
      gsap.set(boxes, {
        y: 24,
        opacity: 0
      });

      gsap.set(icons, {
        scale: 0.8,
        opacity: 0
      });

      ScrollTrigger.batch($(this).find('.icon-box__box'), {
        interval: 0.1, // time window (in seconds) for batching to occur.
        batchMax: 5,   // maximum batch size (targets),
        onEnter: function(batch) {
          const boxes = batch;
          const icons = $(batch).find('.icon-box__icon');
          gsap.to(boxes, {
            y: 0,
            opacity: 1,
            stagger: 0.1
          });

          gsap.to(icons, {
            scale: 1,
            opacity: 1,
            stagger: 0.1
          });
        },
        onLeaveBack: function(batch) {
          const boxes = batch;
          const icons = $(batch).find('.icon-box__icon');

          gsap.set(boxes, {
            y: 24,
            opacity: 0
          });

          gsap.set(icons, {
            scale: 0.8,
            opacity: 0
          });
        },
        start: 'top bottom',
        end: 'bottom top'
      });
    });
  }

  // gallery
  if ( $('.header-hero.has-background-type-video').length ) {
    $('.header-hero.has-background-type-video').each(function(){
      if ( $(this).closest('.header-carousel').length === 0 ) {
        const video = $(this).find('.header-hero__background video, .header-hero__embed');
        const player = new Plyr(video.get(0), {
          controls: ['play', 'mute'],
          hideControls: false,
          autoplay: true,
          muted: true,
          playsinline: true,
          loop: {
            active: true
          }
        });
      }
    });
  }
  
  if ( $('.header-carousel').length ) {
    $('.header-carousel').each(function(){
      const container = $(this).find('.header-carousel__inner');
      const slides = $(this).find('.header-carousel__inner > *');
      const backgrounds = $(this).find('.header-carousel__backgrounds-inner');
      const arrContainer = $(this).find('.header-carousel__controls-arrs');
      const curNum = $(this).find('.header-carousel__controls-nums--cur');
      const totNum = $(this).find('.header-carousel__controls-nums--tot');
      const autoplayToggle = $(this).find('.header-carousel__controls-autoplaytoggle');
      let isAutoplaying = autoplayToggle.hasClass('playing');
      const autoplaySpeed = $(this).data('autoplayspeed');
      
      totNum.text((( slides.length ) + '').padStart(2, '0'));
      
      slides.each(function() {
        if ( $(this).is('.header-hero') ) {
          const clone = $(this).find('.header-hero__background');
          clone.wrap('<div class="header-carousel__backgrounds-slide"></div>');
          
          backgrounds.append(clone.parent());
        }
      });
      
      const players = {
        
      };
      
      $(backgrounds).find('.header-hero__background').each(function(index){
        if ( $(this).is('.is-background-type-video') ) {
          const video = $(this).find('video, .header-hero__embed');
          const player = new Plyr(video.get(0), {
            controls: ['play-large', 'mute'],
            hideControls: false,
            autoplay: index === 1 ? true : false,
            muted: true,
            playsinline: true,
            loop: {
              active: true
            }
          });
          
          players[index] = player;
          
          if ( index === 0 ) {
            player.play();
          }
        }
      });
      
      
      backgrounds.on('init', function(){
        if ( players.hasOwnProperty(0) ) {
          players[0].play();
        }
      }).slick({
        fade: true,
        arrows: false
      });
      
      container.slick({
        swipe: false,
        appendArrows: arrContainer,
        asNavFor: backgrounds,
        prevArrow: prevArrow,
        nextArrow: nextArrow
      });
      
      const autoplayTL = gsap.timeline({
        repeat: -1,
        paused: !isAutoplaying,
        onRepeat: function() {
          $(container).slick('slickNext');
        }
      });
      
      $(container).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        curNum.text(((nextSlide + 1) + '').padStart(2, '0'));
        if ( players.hasOwnProperty(currentSlide) ) {
          players[currentSlide].pause();
        }
        
        if ( isAutoplaying ) {
          autoplayTL.seek(0);
        }
      });
      
      $(container).on('afterChange', function(event, slick, currentSlide){
        if ( players.hasOwnProperty(currentSlide) ) {
          players[currentSlide].play();
        }
      });
       
       
       
      autoplayTL.to($(this).find('.header-carousel__progress-per'), {
        scaleX: 1,
        ease: 'none',
        duration: autoplaySpeed
      });
      
      $(autoplayToggle).on('click', function(){
        isAutoplaying = !isAutoplaying;
        if ( isAutoplaying ) {
          $(autoplayToggle).removeClass('paused');
          $(autoplayToggle).addClass('playing');
          $(this).find('.screen-reader-text').text( $(this).data('pausetext') );
          autoplayTL.play();
          console.log(autoplayTL);
        } else {
          $(autoplayToggle).removeClass('playing');
          $(autoplayToggle).addClass('paused');
          $(this).find('.screen-reader-text').text( $(this).data('playtext') );
          autoplayTL.pause();
        }
      });
    });
  }
  
  if ( $('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo').length ) {
    $('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo').each(function(){
      const target = $(this).find('video, .wp-block-embed__wrapper');
      const el = target.get(0);
      
      const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      
      const args = {
        autoplay: shouldAutoplay,
        controls: $(el).is('video') && el.hasAttribute('controls') ? ( el.getAttribute('controls') === 'false' ? [] : controls ) : ($(el).is('video') ? [] : controls),
        playsinline: el.hasAttribute('playsinline') ? (el.getAttribute('playsinline') === 'true' || el.getAttribute('playsinline') === '') : false,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
        muted: shouldAutoplay ? true : ( el.hasAttribute('muted') ? (el.getAttribute('muted') === 'true' || el.getAttribute('muted') === '') : false )
      };
      
      const player = new Plyr(el, args);
    });
  }
  
  if ( $('.wp-block-audio').length ) {
    $('.wp-block-audio').each(function() {
      const target = $(this).find('audio');
      const el = target.get(0);
      
      const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      
      const args = {
        autoplay: shouldAutoplay,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
      };
      
      const player = new Plyr(el, args);
    });
  }
  
  if ( $('.wp-block-gallery').length ) {
    $('.wp-block-gallery').each(function(){
      gutenbergSlickify(this);
    });
  }
  
  // dropdowns
  if ( $('.clm-dropdown').length ) {
    $('.clm-dropdown').each(function(){
      const container = this;
      const trigger = this.querySelector('.clm-dropdown__toggle');
      const inner = this.querySelector('.clm-dropdown__inner');
      const selectedText = trigger.querySelector('span');
      const optionsList = this.querySelector('.clm-dropdown__dropdown');  
      const options = this.querySelectorAll('.clm-dropdown__dropdown li');
      const hiddenField = this.querySelector('.clm-dropdown__hidden-input');
      const labelEx = options;

      let isExpanded = false;

      $(optionsList).css({
        width: 'auto'
      });

      console.log(  Math.round( ($(optionsList).width() - parseInt($(labelEx).css('padding-left')) - parseInt($(labelEx).css('padding-right')) ) + parseInt($(trigger).css('padding-left')) + parseInt($(trigger).css('padding-right')) ) + 'px' );
      
      $(inner).css({
        'width': Math.round( ($(optionsList).width() - parseInt($(labelEx).css('padding-left')) - parseInt($(labelEx).css('padding-right')) ) + parseInt($(trigger).css('padding-left')) + parseInt($(trigger).css('padding-right')) ) + 'px'
      });
      
      $(optionsList).css({
        width: '100%'
      });

      /**
        Event handlers
      */
      const handleTriggerKeypresses = function (e) {
        switch(e.key) {
          case 'ArrowUp':
            e.preventDefault();
            
            if(isExpanded) {
              selectPreviousOption();
            } else {
              expandOptions();
            }
            
            break;
            
          case 'ArrowDown':
            e.preventDefault();
            
            if(isExpanded) {
              selectNextOption();
            } else {
              expandOptions();
              selectFirstOption();
            }
            
            break;
            
          case 'Home':
            if(isExpanded) {
              selectFirstOption();
            }
            
            break;
            
          case 'End':
            if(isExpanded) {
              selectLastOption();
            }
            
            break;
            
          case 'Tab':
            collapseOptions();
            break;
            
          case 'Escape':
          case 'Enter':
            if(isExpanded) {
              e.preventDefault();
              collapseOptions();
              if ( e.target.closest('[aria-modal="true"]') !== null ) {
                e.stopPropagation();
              }
            }
            
            break;
        }
      }

      const handleBodyClick = function (e) {
        if(!container.contains(e.target) && isExpanded) {
          collapseOptions();
        }
      }

      const handleTriggerClick = function () {
        if(isExpanded) {
          collapseOptions();
          trigger.focus();
        } else {
          expandOptions();
        }
      }


      /**
        Show/hide option list
      */
      const collapseOptions = function () {
        trigger.setAttribute('aria-expanded', false);
        optionsList.classList.remove('is-visible');
        isExpanded = false;
      }

      const expandOptions = function () {
        trigger.setAttribute('aria-expanded', true);
        optionsList.classList.add('is-visible');
        isExpanded = true;
      }


      /**
        Option selection
      */
      const selectFirstOption = function () {
        var firstOption = options[0];
        selectOption(firstOption);
      }

      const selectLastOption = function () {
        var lastOption = options[options.length-1];
        selectOption(lastOption);
      }

      const selectNextOption = function () {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
        
        if(currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
          
          if(currentOptionIndex + 1 < options.length) {
            var nextOption = options[currentOptionIndex + 1];
            selectOption(nextOption);
          }
        }
      }

      const selectPreviousOption = function () {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
        
        if(currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
          
          if(currentOptionIndex - 1 >= 0) {
            var previousOption = options[currentOptionIndex - 1];
            selectOption(previousOption);
          }
        }
      }

      const selectOption = function (option) {
        unselectAllOptions();
        option.setAttribute('aria-selected', true);
        trigger.setAttribute('aria-activedescendant', option.getAttribute('id'));
        selectedText.innerHTML = option.innerHTML;
        
        // Scroll item into view
        
        
        // Update the hidden field
        hiddenField.value = $(option).data('value');
        $(hiddenField).trigger('change');
      }

      const unselectAllOptions = function () {  
        options.forEach(function(option) {
          option.removeAttribute('aria-selected');
        });
      }

      // Handle keyboard and mouse interactions on the trigger bar
      trigger.addEventListener('keydown', handleTriggerKeypresses);
      trigger.addEventListener('click', handleTriggerClick);
      
      // Select options when they are clicked
      options.forEach(function(option) {
        option.addEventListener('click', function(e) {
          unselectAllOptions();
          selectOption(e.target);
          collapseOptions();
          trigger.focus();
        });
      });
      
      // Collapse the dropdown when the user clicks off
      document.addEventListener('click', handleBodyClick);
    });
  }

  //accordion
  if ( $('.accordion-inner').length ) {
    $('.accordion-inner').each(function(){
      const toggle = $(this).find('.accordion-inner__title button');
      const title = $(this).find('.accordion-inner__title');
      const content = $(this).find('.accordion-inner__content');

      if ( ! content.hasClass('open-on-load') ) {
        content.hide();
      }

      toggle.on('click', function(){
        content.slideToggle(400, function(){
          ScrollTrigger.refresh();
        });
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded == 'true' ? 'false' : 'true');
        title.toggleClass('expanded');
      }).on('keypress', handleKeypressADA);
    });
  }
  
  if ( $('.logo-ticker').length ) {
    $('.logo-ticker').each(function() {
      const strip = $(this).find('.logo-ticker__strip');
      const thisRef = this;
      let oldSize = $(window).width();
      let stripW = strip.width();
      let curW = stripW;
      let clones = 0;
      let clonesArr = [];
      
      let speed = isMobile ? stripW / 24 : stripW / 50;
      
      while ( curW && curW !== 0 && curW < oldSize * 2 ) {
        curW += stripW;
        clones++;
        const clone = strip.clone(false);
        $(this).append(clone);
        
        gsap.set(clone, {
          x: ( clones * 100 ) + '%'
        });
        
        clonesArr.push(clone);
      }
      
      const loop = gsap.timeline({
        repeat: -1
      });
      
      loop.to(strip, {
        x: '-=100%',
        ease: 'linear',
        duration: () => {
          return speed;
        }
      });
      
      for ( let i = 0; i < clonesArr.length; i++ ) {
        loop.to(clonesArr[i], {
          x: '-=100%',
          ease: 'linear',
          duration: () => {
            return speed;
          }
        }, '0');
      }
      
      $(window).on('resize', function(){
        speed = isMobile ? stripW / 13 : stripW / 30
        if ( oldSize !== $(window).width() && oldSize < $(window).width() ) {
          const newW = $(window).width();
          if ( newW * 2 > curW ) {
            while ( curW && curW !== 0 && curW < newW * 2 ) {
              curW += stripW;
              clones++;
              const clone = strip.clone(false);
              $(thisRef).append(clone);
              
              gsap.set(clone, {
                x: ( clones * 100 ) + '%'
              });
              
              loop.to(clone, {
                x: '-=100%',
                ease: 'linear',
                duration: () => {
                  return speed;
                }
              }, '0');
              
              clonesArr.push(clone);
            }
            
            oldSize = newW;
          }
        }
      });
    });
  }

  if ( $('.rss-feed').length ) {
    $('.rss-feed').each(function(){
      let allIncidents = [];

      const thisRef = this;
      const lastUpdatedEl = this.querySelector('.rss-feed__last-updated-date');
      const container = this.querySelector('.rss-feed__feed');

      let autoScrollContainer = this.querySelector('.auto-scroll-container');
      let ticker = autoScrollContainer.children[0];
      let tickerClone = ticker.cloneNode(true);
      autoScrollContainer.appendChild(tickerClone);
      
      tickerClone.classList.add('cloned');
      tickerClone.setAttribute('aria-hidden', 'true');

      let timeline = null

      const initTimeline = () => {
        if ( timeline !== null ) {
          timeline.kill();
        }

        const speed = isMobile ? $(ticker).height() / 24 : $(ticker).width() / 50;
        timeline = gsap.timeline({
          repeat: -1
        });

        if ( isMobile ) {
          timeline.to(ticker, {
            y: '-100%',
            ease: 'linear',
            duration: speed,
            overwrite: true
          });

          timeline.to(autoScrollContainer.querySelector('.cloned'), {
            y: '0',
            ease: 'linear',
            duration: speed,
            overwrite: true
          }, '0');
        } else {
          timeline.to(ticker, {
            x: '-100%',
            ease: 'linear',
            duration: speed,
            overwrite: true
          });

          timeline.to(autoScrollContainer.querySelector('.cloned'), {
            x: '0',
            ease: 'linear',
            duration: speed,
            overwrite: true
          }, '0');  
        }
      };

      const resetTimeline = () => {
        autoScrollContainer = thisRef.querySelector('.auto-scroll-container');
        const clones = autoScrollContainer.querySelectorAll('.cloned');
        clones.forEach(function(clone){
          autoScrollContainer.removeChild(clone);
        });

        ticker = autoScrollContainer.children[0];
        gsap.set(ticker, {
          clearProps: 'all'
        });
        tickerClone = ticker.cloneNode(true);
        autoScrollContainer.appendChild(tickerClone);
      
        tickerClone.classList.add('cloned');
        tickerClone.setAttribute('aria-hidden', 'true');
        initTimeline();
      }

      initTimeline();

      function formatTimestamp() {
        const now = new Date();
        return now.toLocaleString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        });
      }

      windowResizeActions.push(function(updated) {
        if ( updated ) {
          resetTimeline();
        }
      });

      function renderCHP() {
        const sorted = allIncidents.slice().sort((a, b) => new Date(b.time) - new Date(a.time));

        const icon = {
          time: `<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.0894 8.49951C15.0892 4.79961 12.0891 1.80029 8.38916 1.80029C4.68934 1.80042 1.69007 4.79969 1.68994 8.49951C1.68994 12.1994 4.68926 15.1996 8.38916 15.1997V16.1997L7.99365 16.189C3.92528 15.983 0.689941 12.6191 0.689941 8.49951C0.690073 4.24741 4.13706 0.800425 8.38916 0.800293C12.6414 0.800293 16.0892 4.24733 16.0894 8.49951L16.0786 8.896C15.8724 12.9641 12.5086 16.1997 8.38916 16.1997V15.1997C12.0892 15.1997 15.0894 12.1995 15.0894 8.49951Z" fill="#2B2D2F"/>
    <path d="M7.88916 3.80371L8.88916 3.80371L8.88916 9L7.88916 9L7.88916 3.80371Z" fill="#2B2D2F"/>
    <path d="M12.1919 7.99951V8.99951H7.88916V7.99951H12.1919Z" fill="#2B2D2F"/>
    </svg>`,
          location: `<svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.47008 3.74634C5.70274 3.74634 4.27002 5.17907 4.27002 6.94641C4.27002 8.71375 5.70274 10.1465 7.47008 10.1465C9.23742 10.1465 10.6701 8.71375 10.6701 6.94641C10.6701 5.17907 9.23742 3.74634 7.47008 3.74634ZM5.3367 6.94641C5.3367 5.76815 6.29187 4.81302 7.47008 4.81302C8.64828 4.81302 9.60345 5.76815 9.60345 6.94641C9.60345 8.12462 8.64828 9.07978 7.47008 9.07978C6.29187 9.07978 5.3367 8.12462 5.3367 6.94641Z" fill="#2B2D2F"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.34559 12.1765C-0.440068 9.39086 -0.440067 4.8744 2.3456 2.08876C5.13125 -0.696904 9.64768 -0.696904 12.4334 2.08876C15.219 4.8744 15.219 9.39086 12.4334 12.1765L7.76663 16.8433C7.55831 17.0516 7.22065 17.0516 7.01232 16.8433L2.34559 12.1765ZM3.09986 2.84302C0.73076 5.21211 0.73076 9.05315 3.09986 11.4223L7.3895 15.7119L11.6791 11.4223C14.0482 9.0532 14.0482 5.21211 11.6791 2.84302C9.31002 0.473924 5.46894 0.473924 3.09986 2.84302Z" fill="#2B2D2F"/>
    </svg>`,
          accident: `<svg width="25" height="13" viewBox="0 0 25 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.112 3.86086C21.6614 3.8438 21.2213 3.72008 20.8278 3.49987C20.4344 3.27966 20.0988 2.96923 19.8486 2.5941L19.7337 2.40161C19.433 1.89706 19.006 1.47964 18.4947 1.19052C17.9834 0.901405 17.4056 0.75059 16.8183 0.752957H11.7916C11.3136 0.755217 10.8413 0.857807 10.4055 1.05409C9.96957 1.25037 9.57975 1.53597 9.2612 1.89242L8.72407 2.42955C7.73167 3.54545 6.37036 4.26633 4.88964 4.46009L2.55172 4.77989C2.08872 4.84762 1.6649 5.07783 1.35604 5.42935C1.04718 5.78087 0.873414 6.23078 0.865815 6.69865V8.4125C0.863331 8.66491 0.911163 8.91528 1.00652 9.14899C1.10187 9.38271 1.24283 9.59508 1.42117 9.77371C1.59951 9.95234 1.81166 10.0936 2.04522 10.1894C2.27878 10.2851 2.52907 10.3333 2.78148 10.3313H4.3494C4.44053 10.8668 4.71824 11.3529 5.13336 11.7033C5.54847 12.0538 6.0742 12.246 6.61746 12.246C7.16072 12.246 7.68645 12.0538 8.10157 11.7033C8.51668 11.3529 8.79439 10.8668 8.88552 10.3313H16.6196C16.7107 10.8668 16.9884 11.3529 17.4035 11.7033C17.8186 12.0538 18.3444 12.246 18.8876 12.246C19.4309 12.246 19.9566 12.0538 20.3717 11.7033C20.7869 11.3529 21.0646 10.8668 21.1557 10.3313H21.9567C22.46 10.3326 22.9443 10.1396 23.3088 9.79254C23.6732 9.44547 23.8896 8.97111 23.9128 8.46839V5.77653C23.905 5.29034 23.7161 4.82456 23.383 4.47027C23.05 4.11598 22.5968 3.89868 22.112 3.86086ZM6.61591 11.4925C6.31103 11.4949 6.01231 11.4066 5.75774 11.2389C5.50318 11.0711 5.30427 10.8314 5.18631 10.5502C5.06836 10.2691 5.03669 9.95919 5.09534 9.66C5.15399 9.36081 5.30031 9.08582 5.51568 8.87001C5.73105 8.6542 6.00574 8.50733 6.30481 8.44807C6.60388 8.38881 6.91382 8.41985 7.19521 8.53723C7.4766 8.65461 7.71671 8.85303 7.88502 9.10726C8.05332 9.36148 8.14221 9.66002 8.14037 9.9649C8.13399 10.3675 7.97143 10.7519 7.68699 11.0369C7.40256 11.3219 7.01851 11.4853 6.61591 11.4925ZM18.8861 11.4925C18.5816 11.4931 18.2838 11.4032 18.0304 11.2343C17.7771 11.0654 17.5796 10.825 17.4631 10.5437C17.3466 10.2624 17.3163 9.95281 17.376 9.65423C17.4357 9.35564 17.5827 9.08153 17.7985 8.86666C18.0142 8.65178 18.2889 8.50584 18.5878 8.44734C18.8866 8.38885 19.196 8.42043 19.4769 8.53809C19.7577 8.65576 19.9973 8.85419 20.1652 9.10822C20.3331 9.36224 20.4217 9.66042 20.4199 9.9649C20.4134 10.3691 20.2496 10.7548 19.9631 11.0401C19.6767 11.3254 19.2903 11.4877 18.8861 11.4925ZM23.1055 8.4125C23.1085 8.56432 23.0808 8.71517 23.0241 8.85604C22.9675 8.99692 22.883 9.12494 22.7758 9.23245C22.6686 9.33996 22.5408 9.42477 22.4001 9.4818C22.2593 9.53883 22.1086 9.56692 21.9567 9.56439H21.1557C21.0907 9.19287 20.9364 8.84274 20.706 8.54417C20.4755 8.24559 20.176 8.00754 19.8331 7.85053L19.7865 7.83191H19.7585L19.6809 7.80086H19.6623L19.5754 7.77291H19.5567L19.4698 7.74808H19.4512L19.3611 7.72634H19.3394L19.2525 7.71082H19.2276H19.1438H19.1158H19.0289H18.7464H18.6594H18.6315H18.5477H18.5197L18.4359 7.72634H18.4111L18.3241 7.74808H18.3055L18.2155 7.77291H18.1968L18.113 7.80086H18.0913L18.0167 7.83191H17.9888L17.9422 7.85053C17.5987 8.00665 17.2986 8.24444 17.068 8.54317C16.8375 8.8419 16.6835 9.1925 16.6196 9.56439H8.88241C8.81847 9.1925 8.66451 8.8419 8.43397 8.54317C8.20343 8.24444 7.9033 8.00665 7.55977 7.85053L7.51941 7.84122H7.49146L7.41695 7.81017H7.39521L7.31139 7.78223H7.29276L7.20893 7.73255H7.1903L7.10336 7.71082H7.07853L6.9947 7.69529H6.96675H6.88292H6.85498H6.76804H6.48551H6.39857H6.37063H6.2868H6.26196L6.17503 7.71082H6.15329L6.06325 7.73255H6.04463L5.95769 7.75739H5.93906L5.85213 7.78533H5.8335L5.75588 7.81638H5.72794L5.68136 7.83501C5.33814 7.99157 5.03829 8.2295 4.80781 8.52815C4.57733 8.8268 4.42317 9.17716 4.35872 9.54886H2.77837C2.6271 9.55261 2.47662 9.52593 2.33585 9.47043C2.19508 9.41492 2.06689 9.33171 1.95888 9.22573C1.85087 9.11975 1.76525 8.99316 1.70709 8.85346C1.64892 8.71377 1.6194 8.56382 1.62028 8.4125V6.69865C1.61443 6.42121 1.71404 6.15187 1.89901 5.945C2.08399 5.73812 2.34055 5.60912 2.61692 5.58403L4.95794 5.27355C6.63291 5.08392 8.1771 4.27696 9.28914 3.01015L9.82627 2.38919C10.0684 2.10854 10.3689 1.88421 10.7067 1.7319C11.0446 1.57958 11.4117 1.50297 11.7823 1.50742H16.8152C17.2604 1.51215 17.6974 1.62827 18.0862 1.8452C18.4751 2.06213 18.8034 2.37296 19.0413 2.74934L19.1562 2.94184C19.4655 3.42949 19.8889 3.83444 20.3899 4.1217C20.8908 4.40895 21.4542 4.56986 22.0313 4.59049C22.3242 4.60726 22.5993 4.73637 22.7995 4.95094C22.9996 5.16551 23.1092 5.449 23.1055 5.74237V8.4125Z" fill="#2B2D2F" stroke="#2B2D2F" stroke-width="0.2"/>
    </svg>`,
          area: `<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.68994 14.4878V15.1997H2.40088V16.1997H0.689941V14.4878H1.68994ZM7.53369 15.1997V16.1997H4.11182V15.1997H7.53369ZM12.6665 15.1997V16.1997H9.24463V15.1997H12.6665ZM16.0894 14.4878V16.1997H14.3774V15.1997H15.0894V14.4878H16.0894ZM1.68994 9.35498V12.7769H0.689941V9.35498H1.68994ZM16.0894 9.35498V12.7769H15.0894V9.35498H16.0894ZM1.68994 4.22217V7.64404H0.689941V4.22217H1.68994ZM16.0894 4.22217V7.64404H15.0894V4.22217H16.0894ZM2.40088 0.800293V1.80029H1.68994V2.51123H0.689941V0.800293H2.40088ZM16.0894 0.800293V2.51123H15.0894V1.80029H14.3774V0.800293H16.0894ZM7.53369 0.800293V1.80029H4.11182V0.800293H7.53369ZM12.6665 0.800293V1.80029H9.24463V0.800293H12.6665Z" fill="#2B2D2F"/>
    </svg>`,
          medical: `<svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" fill="none" stroke="darkgreen" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M12 8v8M8 12h8"/></svg>`,
          fire: `<svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" fill="none" stroke="orangered" stroke-width="2"><path d="M16 13a4 4 0 00-8 0c0 3 4 6 4 6s4-3 4-6z"/><path d="M12 3c1.38 2.49 2 4.5 2 6 0 1.5-1.12 2.5-2 2.5S10 10.5 10 9c0-1.5.62-3.51 2-6z"/></svg>`,
          debris: `<svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" fill="none" stroke="saddlebrown" stroke-width="2"><rect x="3" y="16" width="6" height="4"/><rect x="10" y="14" width="4" height="6"/><rect x="16" y="12" width="5" height="8"/></svg>`,
          weather: `<svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" fill="none" stroke="slategray" stroke-width="2"><path d="M3 16a4 4 0 014-4h1a5 5 0 019.9 1.5A3.5 3.5 0 0121 17H6"/><line x1="8" y1="20" x2="8" y2="22"/><line x1="12" y1="20" x2="12" y2="22"/><line x1="16" y1="20" x2="16" y2="22"/></svg>`
        };

        let html = `
            <div class="auto-scroll-container">
              <ul class="auto-scroll-list list-unstyle rss-feed__feed-list">`;

        sorted.forEach(inc => {
          const formattedTime = inc.timeFormatted;

          let iconType = icon.accident;
          const typeLC = inc.cleanedType.toLowerCase();
          if (typeLC.includes('medical')) iconType = icon.medical;
          else if (typeLC.includes('fire')) iconType = icon.fire;
          else if (typeLC.includes('debris')) iconType = icon.debris;
          else if (typeLC.includes('weather')) iconType = icon.weather;

          let displayType = inc.cleanedType.includes("Major injury")
            ? inc.cleanedType.replace("Major injury", "With Injury")
            : inc.cleanedType;

          html += `
            <li class="rss-feed__feed-list-item has-xs-font-size">
              <div class="rss-feed__feed-list-item-row">
                <span>${icon.time}</span>
                <span><strong>${formattedTime}</strong></span>
              </div>
              <div class="rss-feed__feed-list-item-row">
                <span>${icon.location}</span>
                <span><strong>Location:</strong> ${inc.location}</span>
              </div>
              <div class="rss-feed__feed-list-item-row">
                <span>${icon.area}</span>
                <span><strong>Area:</strong> ${inc.area}</span>
              </div>
              <div class="rss-feed__feed-list-item-row">
                <span>${iconType}</span>
                <span><strong>Type:</strong> ${displayType}</span>
              </div>
            </li>`;
        });

        html += `</ul></div>`;
        container.children[0].remove();

        container.innerHTML = html;
        resetTimeline();
      }

      async function fetchCHP() {
        const container = document.getElementById('chp-feed');
        try {
          const res = await fetch('https://chp-js-9kr5-git-main-john-funnells-projects.vercel.app/api/chp');
          const { incidents } = await res.json();

          if (!incidents || incidents.length === 0) {
            container.innerHTML = "<p>No active CHP incidents at this time.</p>";
            return;
          }

          if (lastUpdatedEl) {
            lastUpdatedEl.textContent = formatTimestamp();
          }

          allIncidents = incidents.slice(0, 100).map(inc => {
            let rawType = inc.type || '';

            const cleanedType = rawType
              .replace(/\d+/g, '')
              .replace(/\bEnrt\b|\bUnkn\b|\bMinor\b|\bno\b/gi, '')
              .replace(/\binj\b/gi, 'Major injury')
              .replace(/Trfc/gi, 'Traffic')
              .replace(/Collision/gi, 'Accident')
              .replace(/-/g, '')
              .replace(/\s{2,}/g, ' ')
              .trim();

            const timeFormatted = inc.time?.replace(/^(\\w+ \\d+)( )(\\d{4}) (.+)$/, '$1, $3 - $4') || inc.time;

            return { ...inc, cleanedType, timeFormatted };
          });

          renderCHP();
        } catch (e) {
          console.error("CHP Fetch Error:", e);
          container.innerHTML = "<p>Unable to load CHP incident feed at the moment. Please try again later.</p>";
        }
      }

      fetchCHP();
      setInterval(fetchCHP, 60000);
    });
  }

 

  if ( $('.testimonials').length ) {
    $('.testimonials').each(function(){
      const container = this;
      
      const list = $(this).find('.testimonials-carousel__inner-blocks');
      const carouselContainer = this.querySelector('.testimonials-carousel');

      const controlsContainer = document.createElement('div');
      controlsContainer.classList.add('testimonials-carousel__controls');
      carouselContainer.insertAdjacentElement('beforebegin', controlsContainer);

      const mobileControlsContainer = document.createElement('div');
      mobileControlsContainer.classList.add('testimonials-carousel__mobile-controls');
      carouselContainer.insertAdjacentElement('afterend', mobileControlsContainer);

      container.style.setProperty('--container-width', $(container).width() + 'px');

      list.slick({
        variableWidth: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        arrowsPlacment: 'beforeSlides',
        appendArrows: controlsContainer,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              dots: true,
              arrowsPlacement: 'split',
              appendArrows: mobileControlsContainer,
              appendDots: mobileControlsContainer,
              dotsClass: 'slick-dots list-unstyle'
            }
          }
        ]
      });
      
      $(window).on('resize', debounce(function(){
        container.style.setProperty('--container-width', $(container).width() + 'px');
      }))
    });
  }
  /* END GUTENBERG SCRIPTS */

  /* ARCHIVE BLOCK SCRIPTS */
  if ( $('.archive-block').length ) {
    $('.archive-block').each(function(){
      const archiveBlock = $(this);
      const archiveFeed = $(this).find('.archive-block__feed');
      const archivePagination = $(this).find('.archive-block__pagination-container');

      const archiveFilterForm = $(this).find('.archive-block__header');
      const archiveSortInputs = $(this).find('.archive-block__sort__input-input');
      const archiveSearchInput = $(this).find('.archive-block__search-input');
      const archiveSearchConfirm = $(this).find('.archive-block__search-confirm');

      const archiveFilterGroups = $(this).find('.archive-block__filter');


      const base = $(this).data('baseurl');
      let currentURL = $(this).data('currenturl');
      const initPage = $(this).data('page');
      const postType = $(this).data('posttype');
      const exclude = $(this).data('exclude');

      let updateArchive;
      let stateObj = {
        base: base,
        url: currentURL,
        page: initPage,
        sort: 'default',
        postType: postType,
        search: false,
        mode: false,
        exclude: exclude,
        taxonomy: false,
        term: false,
        filters: {},
        constantFilters: this.hasAttribute('data-constantfilters') ? $(this).data('constantfilters') : [],
      };

      if ( this.hasAttribute('data-postsper') ) {
        stateObj.postsPerPage = $(this).data('postsper');
      }

      if ( this.hasAttribute('data-cardargs') ) {
        stateObj.cardArgs = $(this).data('cardargs');
      }
      
      if ( this.hasAttribute('data-taxonomy') ) {
        stateObj.taxonomy = $(this).data('taxonomy');
      }
      
      if ( this.hasAttribute('data-term') ) {
        stateObj.term = $(this).data('term');
      }
      
      if ( this.hasAttribute('data-mode') ) {
        stateObj.mode = $(this).data('mode');
      }
      
      if ( this.hasAttribute('data-searchterm') ) {
        stateObj.search = $(this).data('searchterm');
      }

      const updateURLFromFilters = () => {
        const baseurl = base[0] === '/' ? window.location.protocol + base : base;
        const url = new URL(baseurl);
        if ( stateObj.sort !== 'default' ) {
          url.searchParams.append('sort', stateObj.sort);
        }

        if ( stateObj.mode === 'search' && stateObj.search !== false ) {
          url.searchParams.append('s', stateObj.search);
        } else if ( stateObj.search !== false ) {
          url.searchParams.append('search', stateObj.search);
        }

        if ( Object.keys(stateObj.filters).length ) {
          for ( const filterType in stateObj.filters ) {
            if ( Array.isArray(stateObj.filters[filterType]) ) {
              url.searchParams.append(filterType, stateObj.filters[filterType].join(','));
            } else {
              url.searchParams.append(filterType, stateObj.filters[filterType]);
            }
          }
        }

        stateObj.url = url.toString();
        stateObj.page = 1;

        updateArchive();
      };

      if ( archiveFilterGroups.length ) {
        $(archiveFilterGroups).each(function() {
          const inputs = $(this).find('input');

          $(inputs).each(function(){
            const name = $(this).attr('name');
            const type = $(this).attr('type');
            const val = $(this).attr('value');

            if ( $(this).is(':checked') ) {
              if ( type === 'radio' ) {
                stateObj.filters[ name ] = val;
              } else {
                if ( stateObj.filters.hasOwnProperty(name) ) {
                  stateObj.filters[ name ].push( val );
                } else {
                  stateObj.filters[ name ] = [ val ];
                }
              }
            }

            $(this).on('change', function(){
              if ( $(this).is(':checked') ) {
                if ( type === 'radio' ) {
                  stateObj.filters[ name ] = val;
                } else {
                  stateObj.filters[ name ].push( val );
                }
              } else if ( type === 'checkbox' ) {
                stateObj.filters[ name ] = stateObj.filters[name].filter( e => e !== val );
              } else if ( type === 'hidden' ) {
                stateObj.filters[ name ] = $(this).val();
              }
              
              updateURLFromFilters();
            });
          });
        });
      }

      if ( archiveSortInputs.length ) {
        $(archiveSortInputs).each(function(){
          const val = $(this).attr('value');
          
          if ( $(this).is(':checked') ) {
            stateObj.sort = val;
          }
          
          $(this).on('change', function(){
            if ( $(this).is(':checked') ) {
              stateObj.sort = val;
              updateURLFromFilters();
            }
          });
        });
      }

      if ( archiveSearchInput.length ) {
        if ( archiveSearchInput.val() !== '' ) {
          stateObj.search = archiveSearchInput.val();
        }
      }

      if ( archiveSearchConfirm.length ) {
        archiveSearchConfirm.on('click', function(){
          const searchQuery = archiveSearchInput.val();
          if ( searchQuery !== '' ) {
            if ( stateObj.search !== searchQuery ) {
              stateObj.search = searchQuery;
            }

            updateURLFromFilters();
          } else {
            if ( stateObj.search !== false ) {
              stateObj.search = false;
              updateURLFromFilters();
            }
          }
        }).on('keypress', handleKeypressADA);
      }

      if ( archiveFilterForm.length ) {
        archiveFilterForm.on('submit', function(e){
          e.preventDefault();
          if ( archiveSearchConfirm.length ) {
            archiveSearchConfirm.trigger('click');
          }
        });
      }



      $(archivePagination).on('click', 'a', function(e){
        e.preventDefault();
        if ( ajaxIsLoading === false ) {
          const url = $(e.target).attr('href');
          let page = 1;
          const urlparts = url.split('?')[0].split('/');
          let parsedNum = false;
          for ( let i = urlparts.length - 1; i >= 0; i-- ) {
            if ( urlparts[ i ] != '' ) {
              const parsed = parseInt( urlparts[ i ] );
              if ( !isNaN(parsed) ) {
                parsedNum = parsed;
                break;
              }
            }
          }

          if ( parsedNum !== false ) {
            page = parsedNum;
          }

          console.log(page);


          stateObj.url = url;
          stateObj.page = page;

          updateArchive();
        }
      }).on('keypress', 'a', function(e){
        e.preventDefault();
        $(this).trigger('click');
      });

      const initState = stateObj;

      window.addEventListener('popstate', function(event){
        if ( Object.keys(event.state).length == 0 ) {
          stateObj = initState;
        } else {
          stateObj = event.state;
        }

        updateArchive(true);
      });


      updateArchive = (frompopstate = false) => {
        ajaxIsLoading = true;
        $(archiveBlock).addClass('loading');
        if ( smooth !== null ) {
          gsap.to(smooth, {
            // don't let it go beyond the maximum scrollable area
            scrollTop: Math.min(
              ScrollTrigger.maxScroll(window),
              smooth.offset(archiveBlock, "top 100px")
            ),
            duration: 1,
          });
        } else {
          gsap.to(window, {
            scrollTo: archiveBlock.get(0),
            duration: 0.8,
            ease: 'power1.inOut'
          });
        }


        if ( frompopstate === false ) {
          history.pushState(stateObj, '', stateObj.url);
        }

        const args = {
          paged: stateObj.page,
          base: stateObj.base,
          sort: stateObj.sort,
          postType: stateObj.postType,
          exclude: stateObj.exclude,
          taxonomy: stateObj.taxonomy,
          term: stateObj.term,
          mode: stateObj.mode
        };

        if ( stateObj.search !== false ) {
          args.search = stateObj.search;
        } if ( stateObj.hasOwnProperty('postsPerPage') ) {
          args.postsPerPage = stateObj.postsPerPage;
        } if ( stateObj.hasOwnProperty('cardArgs') ) {
          args.cardArgs = stateObj.cardArgs;
        } if ( stateObj.hasOwnProperty('filters') && Object.keys(stateObj.filters).length ) {
          args.filters = stateObj.filters;
        } if ( stateObj.hasOwnProperty('constantFilters') && stateObj.constantFilters.length ) {
          args.constantFilters = stateObj.constantFilters;
        }

        console.log(args);

        $.post(clmVars.ajaxURL, {
          action: 'clm_get_archive',
          args: args
        }, function(data) {
          console.log(data);
          try {
            const res = JSON.parse(data);
            const state = Flip.getState( archiveFeed.get(0).querySelector('li') );
            console.log(res);

            $(archiveFeed).html( res.results );
            $(archivePagination).html( res.pagination );
            
            ScrollTrigger.refresh();

            Flip.from(state, {
              absolute: true,
              duration: 0.6,
              onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1}),
              onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0}),
            });
          } catch (err) {
            console.log( err );
          }
        }).always(function(){
          $(archiveBlock).removeClass('loading');
          ajaxIsLoading = false;
        });
      };
    });
  }
  /* END ARCHIVE BLOCK SCRIPTS */
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  let oldState = isMobile;
  let oldNavState = isMobileChatActive;
  isMobile = ( windowWidth <= mobileBreakpoint );
  isMobileChatActive = ( windowWidth <= navBreakpoint );
  if ( windowResizeActions.length > 0 ) {
    const updated = oldState != isMobile;
    const navUpdated = oldNavState != isMobileChatActive;
    for (var i = 0; i < windowResizeActions.length; i++) {
      windowResizeActions[i](updated, navUpdated);
    }
  }
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

/*
 * Functions
 ***************************/
function gutenbergSlickify(el) {
  const count = $(el).find('figure').length;

  const captions = [];

  $(el).find('figure').each(function(){
    if ( $(this).find('figcaption').length ) {
      $(this).addClass('has-caption');
      captions.push( $(this).find('figcaption').clone(true) );
      $(this).find('figcaption').remove();
    } else {
      captions.push('<div style="height:10px;"></div>');
    }
  });

  $(el).find('.blocks-gallery-item').each(function(){
    $(this).addClass('slick-gallery-item').removeClass('blocks-gallery-item');
  });

  $(el).find('.blocks-gallery-item__caption').each(function(){
    $(this).addClass('slick-gallery-item__caption').removeClass('blocks-gallery-item__caption');
  });

  $(el).addClass('slick-gallery-grid').removeClass('blocks-gallery-grid');

  $(el).removeClass('wp-block-gallery').wrap('<div></div>');
  const parent = $(el).parent();
  parent.addClass('slick-gallery').addClass('alignwide').removeClass('wp-block-gallery').append('<div class="slick-gallery-nav"><div class="slick-gallery-nav__inner"><div class="slick-gallery-nav__count"><b><span class="slick-gallery-nav__count__cur">1</span></b> / <b>' + count +'</b></div><div class="slick-gallery-nav__captions-outer"><div class="slick-gallery-nav__captions"></div></div></div>');


  const nav = $(el).parent().find('.slick-gallery-nav');
  const captionsContainer = nav.find('.slick-gallery-nav__captions');
  for (let i = 0; i < captions.length; i++) {
    captionsContainer.append( captions[i] );
  }

  captionsContainer.slick({
    adaptiveHeight: true,
    arrows: false,
    swipe: false,
    fade: true
  });

  $(el).slick({
    adaptiveHeight: true,
    // prevArrow: prevArrow,
    // nextArrow: nextArrow,
    appendArrows: nav,
    asNavFor: captionsContainer,
  });

  $(el).on('beforeChange', function(event, slick, currentSlide, nextSlide){
    nav.find('.slick-gallery-nav__count__cur').text(nextSlide + 1);
  });
}

// Post Header Height
// jQuery(document).ready(function($) {
//   function updateHeaderHeight() {
//     var headerTitle = $('.post-header__title').outerHeight(true);
//     var headerContainer = $('.post-header');
//     var siteHeaderHeight = $('.site-header').height();
//     var newHeight = headerTitle + siteHeaderHeight + 145 + 'px';

//     if ($(window).width() < 959) {
//       newHeight = headerTitle + siteHeaderHeight + 160 + 'px';
//     }
//     if ($(window).width() < 768) {
//       newHeight = headerTitle + siteHeaderHeight + 120 + 'px';
//     }

//     headerContainer.css('height', newHeight);
//   }

//   updateHeaderHeight();
//   $(window).resize(updateHeaderHeight);
// });

// Custom Search Close Button
$(document).ready(function() {
  $('.search-close').on('click', function() {
    $('.site-searchform__input').val('');
  });
});


/* CHAT INTEGRATION */
document.addEventListener('DOMContentLoaded', function() {
  // Configuration - Update this with your actual API endpoint
  const API_ENDPOINT = clmVars.chatAPIEndpoint; // TODO: Replace with actual endpoint
  
  // Initialize mobile debug tools
  initMobileDebugTools();

  // SESSION ID (persist across messages)
  const SESSION_STORAGE_KEY = 'clm_chat_session_id';
  let sessionId = window.localStorage.getItem(SESSION_STORAGE_KEY) || '';

  // UUID generation utility for creating session IDs
  function generateUUID() {
    // Simple UUID v4 generation
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  // Initialize session ID - generate one if none exists
  function initializeSessionId() {
    if (!sessionId) {
        sessionId = generateUUID();
        window.localStorage.setItem(SESSION_STORAGE_KEY, sessionId);
    }
    return sessionId;
  }

  // CHAT PERSISTENCE KEYS
  const CHAT_STATE_KEY = 'clm_chat_session';
  const CHAT_HISTORY_KEY = 'clm_chat_history';
  const CHAT_COMPLETED_KEY = 'clm_chat_complete';
  const QUESTIONS_COMPLETED_KEY = 'clm_questions_completed';

  function setSessionId(newId) {
    if (!newId) return;
    sessionId = newId;
    window.localStorage.setItem(SESSION_STORAGE_KEY, newId);
  }

  function clearSessionId() {
    sessionId = '';
    window.localStorage.removeItem(SESSION_STORAGE_KEY);
  }

  // CHAT PERSISTENCE FUNCTIONS
  function saveChatState() {
    try {
      const chatState = {
        formData: formData,
        currentQuestion: currentQuestion,
        sessionId: sessionId,
        timestamp: Date.now()
      };
      window.localStorage.setItem(CHAT_STATE_KEY, JSON.stringify(chatState));
    } catch (error) {
      console.warn('Failed to save chat state:', error);
    }
  }

  function loadChatState() {
    try {
      const savedState = window.localStorage.getItem(CHAT_STATE_KEY);
      return savedState ? JSON.parse(savedState) : null;
    } catch (error) {
      console.warn('Failed to load chat state:', error);
      return null;
    }
  }

  function saveChatHistory(message) {
    try {
      let history = window.localStorage.getItem(CHAT_HISTORY_KEY);
      history = history ? JSON.parse(history) : [];
      
      // Check if this is Sofia's initial message and prevent duplicates
      const isSofiaInitialMessage = message.type === 'incoming' && 
        message.text.includes("Hi, I'm Sofia!") && 
        message.text.includes("ready to help you find");
      
      if (isSofiaInitialMessage) {
        const existingSofiaMessage = history.find(msg => 
          msg.type === 'incoming' && 
          msg.text.includes("Hi, I'm Sofia!") && 
          msg.text.includes("ready to help you find")
        );
        if (existingSofiaMessage) {
          // Don't save duplicate Sofia message
          return;
        }
      }
      
      // Check if this is a question and prevent duplicates
      const isQuestionMessage = message.type === 'incoming' && 
        message.text.match(/\(\d+\/\d+\)$/); // Has progress indicator like "(1/8)"
      
      if (isQuestionMessage) {
        const existingQuestion = history.find(msg => 
          msg.type === 'incoming' && 
          msg.text === message.text
        );
        if (existingQuestion) {
          // Don't save duplicate question
          return;
        }
      }
      
      history.push({
        ...message,
        timestamp: Date.now()
      });
      window.localStorage.setItem(CHAT_HISTORY_KEY, JSON.stringify(history));
      updateLastActivity();
    } catch (error) {
        console.warn('Failed to save chat history:', error);
    }
  }

  function loadChatHistory() {
    try {
      const history = window.localStorage.getItem(CHAT_HISTORY_KEY);
      return history ? JSON.parse(history) : [];
    } catch (error) {
      console.warn('Failed to load chat history:', error);
      return [];
    }
  }

  function clearChatData() {
    try {
      window.localStorage.removeItem(CHAT_STATE_KEY);
      window.localStorage.removeItem(CHAT_HISTORY_KEY);
      window.localStorage.removeItem(QUESTIONS_COMPLETED_KEY);
      window.localStorage.removeItem(CHAT_COMPLETED_KEY);
      window.localStorage.removeItem('clm_chat_last_activity');
      clearSessionId();
    } catch (error) {
      console.error('Error clearing chat data:', error);
    }
  }

  function isConversationCompleted() {
    return window.localStorage.getItem(CHAT_COMPLETED_KEY) === 'true';
  }

  function getConversationCompletionType() {
    const savedHistory = loadChatHistory();
    const questionsCompleted = areQuestionsCompleted();
    
    if (!questionsCompleted) return 'none';
    
    // Check if user made a choice in chat history
    const choseToChat = savedHistory.some(msg => 
      msg.type === 'outgoing' && msg.text === "Yes, I want to chat"
    );
    const choseToSubmit = savedHistory.some(msg => 
      msg.type === 'outgoing' && msg.text === "No, submit my information"
    );
    
    if (choseToChat) return 'chat';
    if (choseToSubmit) return 'submission';
    return 'none';
  }

  function areQuestionsCompleted() {
    return window.localStorage.getItem(QUESTIONS_COMPLETED_KEY) === 'true';
  }

  function markQuestionsCompleted() {
    window.localStorage.setItem(QUESTIONS_COMPLETED_KEY, 'true');
  }

  function markConversationCompleted() {
    window.localStorage.setItem(CHAT_COMPLETED_KEY, 'true');
  }

  // Chat expiration functions
  function updateLastActivity() {
    window.localStorage.setItem('clm_chat_last_activity', Date.now().toString());
  }

  function isChatDataExpired() {
    const lastActivity = window.localStorage.getItem('clm_chat_last_activity');
    if (!lastActivity) return false;
    
    const expirationTime = 24 * 60 * 60 * 1000; // 24 hours in ms
    return (Date.now() - parseInt(lastActivity)) >= expirationTime;
  }

  // Chat elements
  const chatMessages = document.getElementById('chat-messages');
  const chatInput = document.getElementById('message-input');
  const chatForm = document.getElementById('chat-form');
  const sendButton = document.getElementById('send-button');
  const completeMessage = document.getElementById('conversation-complete-message');

  // Auto-resize textarea functionality
  function autoResizeTextarea() {
    if (!chatInput) return;
    
    // Reset height to auto to get the correct scrollHeight
    chatInput.style.height = 'auto';
    
    // Calculate new height based on content
    const lineHeight = 21; // Based on font-size (1.4rem) and line-height (1.4)
    const padding = 20; // 10px top + 10px bottom
    const scrollHeight = chatInput.scrollHeight;
    const newHeight = Math.min(scrollHeight, 152); // Max 4 lines (38px * 4)
    
    chatInput.style.height = newHeight + 'px';
  }

  // Add event listeners for auto-resize
  if (chatInput) {
    // Resize on input
    chatInput.addEventListener('input', autoResizeTextarea);
    
    // Resize on paste (with slight delay for content to be pasted)
    chatInput.addEventListener('paste', function() {
      setTimeout(autoResizeTextarea, 10);
    });
    
    // Resize on cut (with slight delay for content to be cut)
    chatInput.addEventListener('cut', function() {
      setTimeout(autoResizeTextarea, 10);
    });
    
    // Handle Enter key for new lines vs submit
    chatInput.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        // Prevent default new line behavior
        event.preventDefault();
        
        // If textarea has multiple lines and shift is not pressed, submit form
        if (chatForm && !chatInput.disabled) {
          chatForm.dispatchEvent(new Event('submit'));
        }
      }
        // Allow Shift+Enter for new lines
    });
    
    // Initial resize
    autoResizeTextarea();
  }



  // Create typing indicator element
  const typingIndicator = document.createElement('div');
  typingIndicator.id = 'typing-indicator';
  typingIndicator.className = 'typing-indicator message incoming';
  typingIndicator.innerHTML = '<span></span><span></span><span></span>';

  // Form data storage
  const formData = {
    accidentType: '',
    inCalifornia: '',
    whenHappened: '',
    injuries: '',
    treatment: '',
    name: '',
    email: '',
    phoneNumber: ''
  };

  // Track current question
  let currentQuestion = 0;
  const totalQuestions = 8;

  // Question definitions - Add new contact questions
  const questions = [
      {
        text: "What type of accident or injury were you involved in?",
        options: [
            { value: "Car Accident", icon: "directions_car" },
            { value: "Commercial Truck Accident", icon: "local_shipping" },
            { value: "Uber/Lyft (Rideshare) Accident", icon: "local_taxi" },
            { value: "Pedestrian or Bicycle Accident", icon: "pedal_bike" },
            { value: "Motorcycle Injury", icon: "two_wheeler" },
            { value: "Slip, Trip, or Fall Injury", icon: "downhill_skiing" },
            { value: "Dog Bite or Animal Attack", icon: "pets" },
            { value: "Hit and Run Accident", icon: "directions_run" },
            { value: "Workplace Injury or Accident", icon: "work" }
        ],
        formField: 'accidentType'
    },

    {
        text: "Did the accident or injury happen in California?",
        options: [
            { value: "Yes", icon: "check_circle" },
            { value: "No", icon: "cancel" }
        ],
        formField: 'inCalifornia'
    },
    {
        text: "When did the accident or injury happen?",
        options: [
            { value: "Within the last 3 days", icon: "today" },
            { value: "Within the last 3 months", icon: "date_range" },
            { value: "3 months to 2 years ago", icon: "event" },
            { value: "More than 2 years ago", icon: "event_busy" }
        ],
        formField: 'whenHappened'
    },
    {
        text: "What were the injuries? (Select the most relevant)",
        options: [
            { value: "Back / Neck Injury", icon: "accessibility" },
            { value: "Head Injury", icon: "psychology" },
            { value: "Broken bone", icon: "orthopedics" },
            { value: "Death", icon: "feedback" },
            { value: "Other", icon: "healing" },
              { value: "Not sure at this time", icon: "help" }
          ],
          formField: 'injuries'
      },
      {
          text: "What was the treatment?",
          options: [
              { value: "ER or Doctor Visit", icon: "local_hospital" },
              { value: "Surgery Done or Recommended", icon: "medical_services" },
              { value: "Physical Therapy", icon: "accessibility_new" },
              { value: "Other", icon: "medication" },
              { value: "No Treatment So Far", icon: "do_not_disturb" },
              { value: "Not Applicable – Filling Out for a Loved One", icon: "people" }
          ],
          formField: 'treatment'
      },
      // New contact information questions
      {
          text: "Please provide your full name:",
          type: "text",
          formField: 'name',
          placeholder: "Enter your full name",
          validation: (value) => {
            const trimmedValue = value.trim();
            if (trimmedValue === "") return false;
            
            const nameParts = trimmedValue.split(/\s+/).filter(part => part.length > 0);
            return nameParts.length >= 2;
        },
        errorMessage: "Please provide both your first and last name"
      },
      {
          text: "What's your email address?",
          type: "email",
          formField: 'email',
          placeholder: "example@email.com",
          validation: (value) => {
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              return emailRegex.test(value);
          },
          errorMessage: "Please enter a valid email address"
      },
      {
          text: "What's your phone number?",
          type: "tel",
          formField: 'phoneNumber',
          placeholder: "(555) 123-4567",
          validation: (value) => {
              // Simple validation - just make sure there are at least 10 digits
              const phoneDigits = value.replace(/\D/g, '');
              return phoneDigits.length >= 10;
          },
          errorMessage: "Please enter a valid phone number"
      }
  ];

  // Phone number formatting function
  function formatPhoneNumber(value) {
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, '');
    
    // Apply formatting based on length
    if (cleaned.length === 0) {
      return '';
    } else if (cleaned.length <= 3) {
      return `(${cleaned}`;
    } else if (cleaned.length <= 6) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    } else {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    }
  }

  // Start conversation
  function startConversation() {
    // Check if chat data is expired first
    if (isChatDataExpired()) {
      clearChatData();
    }
    
    // Try to load saved state and history
    const savedState = loadChatState();
    const savedHistory = loadChatHistory();
      
    // Check if conversation is already completed
    if (isConversationCompleted()) {
      // Show completion state with Start Over button
      // If there's saved history, restore it above the completion message
      showCompletedState(true, savedState, savedHistory);
      return;
    }
    
    // Check if there's a saved conversation to restore
    if (savedState && savedHistory.length > 0 && !isConversationCompleted()) {
      // Only restore if conversation is not completed
      restoreConversation(savedState, savedHistory);
    } else {
      // Start fresh conversation and initialize activity
      updateLastActivity();
      createIncomingMessageWithHistory("Hi, I'm Sofia! I'm ready to help you find best possible attorneys for your accident or injury. Let's get started.");
      
      // Show the first question after a short delay
      setTimeout(() => {
          showNextQuestion();
      }, 1000);
    }
  }
  
  // Restore previous conversation using chat history as single source of truth
  function restoreConversation(savedState, savedHistory) {
    // Update activity timestamp when restoring conversation
    updateLastActivity();
    
    // Check if conversation is completed - if so, don't restore as ongoing conversation
    if (isConversationCompleted()) {
      // Let startConversation handle completed state properly
      return;
    }
    
    // Restore form data and current question
    Object.assign(formData, savedState.formData);
    currentQuestion = savedState.currentQuestion;
    if (savedState.sessionId) {
        setSessionId(savedState.sessionId);
    }
    
    // Clear chat messages container
    chatMessages.innerHTML = '';
    
    // Render all messages from history in order
    savedHistory.forEach((msg, index) => {
      const messageDiv = document.createElement('div');
      messageDiv.classList.add('message', msg.type);
      
      if (msg.type === 'incoming') {
        // Check if this is a question message and render with options
        // Remove progress indicator for matching (e.g., " (1/8)")
        const textWithoutProgress = msg.text.replace(/\s*\(\d+\/\d+\)$/, '');
        const questionIndex = questions.findIndex(q => textWithoutProgress.includes(q.text));
        if (questionIndex !== -1 && questionIndex < savedState.currentQuestion) {
          const question = questions[questionIndex];
          const answer = savedState.formData[question.formField];
          
          // Render question with number
          const questionTextDiv = document.createElement('div');
          questionTextDiv.textContent = `${question.text} (${questionIndex + 1}/${totalQuestions})`;
          messageDiv.appendChild(questionTextDiv);
          
          // Add options if it's a multiple choice question
          if (question.options) {
            const optionsDiv = document.createElement('div');
            optionsDiv.classList.add('chat-input-options-inline');
            
            question.options.forEach(option => {
              const optionButton = document.createElement('button');
              optionButton.classList.add('chat-option-btn-inline');
              optionButton.innerHTML = `<span class="chat-option-btn-inline--icon">${clmIcons.hasOwnProperty(option.icon) ? clmIcons[option.icon] : 'Missing icon: ' + option.icon}</span> ${option.value}`;
              
              // Highlight the selected answer and disable all options
              if (answer === option.value) {
                optionButton.classList.add('selected');
              }
              
              // Disable all options
              optionButton.disabled = true;
              optionButton.classList.add('disabled');
              
              optionsDiv.appendChild(optionButton);
            });
            
            messageDiv.appendChild(optionsDiv);
          } else if (question.type === "text" || question.type === "email" || question.type === "tel") {
            // Show the user's answer for text input questions
            if (answer) {
              const answerDiv = document.createElement('div');
              answerDiv.classList.add('text-input-answer');
              answerDiv.textContent = answer;
              answerDiv.style.fontStyle = 'italic';
              answerDiv.style.color = '#666';
              answerDiv.style.marginTop = '8px';
              answerDiv.style.padding = '8px';
              answerDiv.style.backgroundColor = '#f5f5f5';
              answerDiv.style.borderRadius = '4px';
              messageDiv.appendChild(answerDiv);
            }
          }
        } else {
          // Regular incoming message
          messageDiv.textContent = msg.text;
        }
      } else if (msg.type === 'outgoing') {
        messageDiv.textContent = msg.text;
        if (msg.timestamp) {
          const timestamp = new Date(msg.timestamp).toLocaleTimeString('en-US', { 
              hour: 'numeric', 
              minute: '2-digit',
              hour12: true 
          });
          messageDiv.setAttribute('data-timestamp', timestamp);
        }
      }
      
      chatMessages.appendChild(messageDiv);
    });
    
    // Only add "Continuing your previous conversation" message if conversation is NOT completed
    if (!isConversationCompleted()) {
      const continueMsg = document.createElement('div');
      continueMsg.classList.add('message', 'system');
      const historyIcon = clmIcons && clmIcons.hasOwnProperty('history') ? clmIcons['history'] : '📜';
      continueMsg.innerHTML = `<div style="display: flex; align-items: center; gap: 8px;"><span class="chat-option-btn-inline--icon">${historyIcon}</span><span>Continuing your previous conversation...</span></div>`;
      
      // Insert the continuation message before the last message (but before we add Start Over button)
      chatMessages.appendChild(continueMsg);
      
      // Add "Start Over" button BELOW the "Continuing..." message
      addStartOverButton();
    }
    
    // Handle mobile input visibility
    if (isMobile) {
      // Hide chat input if user is still answering initial questions
      if (currentQuestion < totalQuestions) {
        hideChatInput();
      }
    }
    
    // Handle next steps based on conversation state
    if (currentQuestion < totalQuestions) {
      // Show next question
      setTimeout(() => {
          showNextQuestion();
      }, 1000);
    } else {
      // Check if user has made chat/submit choice
      const chatChoiceMade = savedHistory.some(msg => 
        msg.type === 'outgoing' && (
          msg.text === "Yes, I want to chat" || 
          msg.text === "No, submit my information"
        )
      );
      
      if (!chatChoiceMade) {
        // Show AI chat option question
        const messageDiv = document.createElement('div');
        messageDiv.classList.add('message', 'incoming');
        messageDiv.textContent = "Would you like to chat with our AI assistant to provide more details about your case?";
      
        // Add Yes/No options
        const optionsDiv = document.createElement('div');
        optionsDiv.classList.add('chat-input-options-inline');
      
        // Yes button
        const yesButton = document.createElement('button');
        yesButton.classList.add('chat-option-btn-inline');
        yesButton.innerHTML = `<span class="chat-option-btn-inline--icon">${clmIcons.hasOwnProperty('chat') ? clmIcons['chat'] : 'Missing icon: ' + 'chat'}</span> Yes, I want to chat`;
        yesButton.addEventListener('click', function() {
            handleChatOptionSelection(true);
        });
        optionsDiv.appendChild(yesButton);
      
        // No button
        const noButton = document.createElement('button');
        noButton.classList.add('chat-option-btn-inline');
        noButton.innerHTML = `<span class="chat-option-btn-inline--icon">${clmIcons.hasOwnProperty('send') ? clmIcons['send'] : 'Missing icon: ' + 'send'}</span> No, submit my information`;
        noButton.addEventListener('click', function() {
            handleChatOptionSelection(false);
        });
        optionsDiv.appendChild(noButton);
      
        messageDiv.appendChild(optionsDiv);
        chatMessages.appendChild(messageDiv);
      } else {
        // User has made choice, enable chat if they want to continue
        const wantsToChat = savedHistory.some(msg => 
          msg.type === 'outgoing' && msg.text === "Yes, I want to chat"
        );
        
        if (wantsToChat) {
          // Enable form for continued conversation
          if (chatForm) {
            chatForm.classList.remove('disabled');
            chatInput.disabled = false;
            sendButton.disabled = false;
            chatInput.placeholder = 'Your message here...';
          }
          // Show the chat form container and make input visible
          showChatForm();
          showChatInput();
        }
      }
    }
    
    scrollToBottom();
  }
  
  // Add "Start Over" button to chat
  function addStartOverButton() {
      // Check if Start Over button already exists
    const existingButton = document.querySelector('.chat-start-over-container');
    if (existingButton) {
        return; // Don't add duplicate button
    }
    
    const buttonContainer = document.createElement('div');
    buttonContainer.classList.add('chat-start-over-container');
    
    const startOverBtn = document.createElement('button');
    startOverBtn.classList.add('chat-start-over-btn');
    const refreshIcon = clmIcons && clmIcons.hasOwnProperty('refresh') ? clmIcons['refresh'] : '🔄';
    startOverBtn.innerHTML = `<span class="chat-option-btn-inline--icon">${refreshIcon}</span> Start Over`;
    startOverBtn.addEventListener('click', handleStartOver);
    
    buttonContainer.appendChild(startOverBtn);
    chatMessages.appendChild(buttonContainer);
  }
  
  // Handle "Start Over" button click
  function handleStartOver() {
    showStartOverModal();
  }
  
  // Show custom start over modal
  function showStartOverModal() {
    // Create modal if it doesn't exist
    let modal = document.getElementById('startOverModal');
    if (!modal) {
        modal = createStartOverModal();
    }
    
    // Show modal with animation
    modal.classList.add('active');
    
    // Focus management
    const confirmBtn = modal.querySelector('.start-over-modal__btn--confirm');
    confirmBtn.focus();
    
    // Add keyboard event listener
    modal.addEventListener('keydown', handleModalKeydown);
  }
  
  // Hide start over modal
  function hideStartOverModal() {
    const modal = document.getElementById('startOverModal');
    if (modal) {
      modal.classList.remove('active');
      modal.removeEventListener('keydown', handleModalKeydown);
    }
  }
  
  // Handle keyboard events in modal
  function handleModalKeydown(e) {
    if (e.key === 'Escape') {
      hideStartOverModal();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      confirmStartOver();
    }
  }
  
  // Confirm start over action
  function confirmStartOver() {
    hideStartOverModal();
    clearChatData();
    hideChatInput();
    chatMessages.innerHTML = '';
    currentQuestion = 0;
    createIncomingMessageWithHistory("Hi, I'm Sofia! I'm ready to help you find the best possible attorneys for your accident or injury. Let's get started.");
    
    setTimeout(() => {
        showNextQuestion();
    }, 1000);
  }
  
  // Create the start over modal element
  function createStartOverModal() {
    const modal = document.createElement('div');
    modal.id = 'startOverModal';
    modal.className = 'start-over-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'startOverModalTitle');
    
    modal.innerHTML = `
        <div class="start-over-modal__overlay"></div>
        <div class="start-over-modal__dialog">
            <div class="start-over-modal__content">
                <p id="startOverModalTitle">Are you sure you want to start over? This will clear your current conversation.</p>
            </div>
            <div class="start-over-modal__actions">
                <button class="start-over-modal__btn start-over-modal__btn--cancel" type="button">Cancel</button>
                <button class="start-over-modal__btn start-over-modal__btn--confirm" type="button">Start Over</button>
            </div>
        </div>
    `;
      
    // Add event listeners
    const cancelBtn = modal.querySelector('.start-over-modal__btn--cancel');
    const confirmBtn = modal.querySelector('.start-over-modal__btn--confirm');
    const overlay = modal.querySelector('.start-over-modal__overlay');
    
    cancelBtn.addEventListener('click', hideStartOverModal);
    confirmBtn.addEventListener('click', confirmStartOver);
    overlay.addEventListener('click', hideStartOverModal);
    
    // Add to body
    document.body.appendChild(modal);
    
    return modal;
  }
  
  // Create incoming message and save to history (for system messages)
  function createIncomingMessageWithHistory(message) {
    createIncomingMessage(message);
    saveChatHistory({
      type: 'incoming',
      text: message
    });
  }

  // Show the next question
  function showNextQuestion() {
    if (currentQuestion < questions.length) {
      const question = questions[currentQuestion];
    
      // Create a message with question number indicator
      const messageDiv = document.createElement('div');
      messageDiv.classList.add('message', 'incoming');
    

      // Add question text with progress
      const questionTextDiv = document.createElement('div');
      const questionText = `${question.text} (${currentQuestion + 1}/${totalQuestions})`;
      questionTextDiv.textContent = questionText;
      messageDiv.appendChild(questionTextDiv);
      
      // Save question to chat history
      saveChatHistory({
        type: 'incoming',
        text: questionText
      });
    
      // Check if it's a multiple choice or text input question
      if (question.type === "text" || question.type === "email" || question.type === "tel") {
        // Create text input
        const textInputContainer = document.createElement('div');
        textInputContainer.classList.add('text-input-container');
      
        const textInput = document.createElement('input');
        textInput.type = question.type;
        textInput.classList.add('text-input-field');
        textInput.placeholder = question.placeholder;
        textInput.id = `${question.formField}-input`;
        
        // Add phone formatting for phone inputs
        if (question.type === "tel") {
          textInput.addEventListener('input', function(e) {
            const value = e.target.value;
            const formatted = formatPhoneNumber(value);
            
            // Only update if formatting changed
            if (formatted !== value) {
              // Save cursor position
              const start = e.target.selectionStart;
              const end = e.target.selectionEnd;
      
              // Update value
              e.target.value = formatted;
              
              // Restore cursor position (adjusted for formatting)
              const cursorOffset = formatted.length - value.length;
              e.target.setSelectionRange(start + cursorOffset, end + cursorOffset);
            }
          });
              
          // Prevent non-numeric characters
          textInput.addEventListener('keydown', function(e) {
            // Allow backspace, delete, tab, escape, enter
            if ([8, 9, 27, 13, 46].indexOf(e.keyCode) !== -1 ||
                // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                (e.keyCode === 65 && e.ctrlKey === true) ||
                (e.keyCode === 67 && e.ctrlKey === true) ||
                (e.keyCode === 86 && e.ctrlKey === true) ||
                (e.keyCode === 88 && e.ctrlKey === true)) {
                return;
            }
            // Ensure that it's a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
          });
        }
          
        textInputContainer.appendChild(textInput);
      
        // Create error message
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('text-input-error');
        errorMessage.id = `${question.formField}-error`;
        errorMessage.textContent = question.errorMessage;
        textInputContainer.appendChild(errorMessage);
      
        // Create submit button
        const submitButton = document.createElement('button');
        submitButton.type = 'button';
        submitButton.classList.add('text-input-submit');
        submitButton.innerHTML = `<span class="chat-option-btn-inline--icon">${clmIcons.hasOwnProperty('arrow_forward') ? clmIcons['arrow_forward'] : 'Missing icon: ' + 'arrow_forward'}</span> Continue`;
        
        // Add click event for text inputs
        submitButton.addEventListener('click', function() {
          const inputValue = textInput.value;
          const isValid = question.validation(inputValue);
          const errorElement = document.getElementById(`${question.formField}-error`);
        
          if (isValid) {
            // Hide error and remove red color
            errorElement.style.display = 'none';
            errorElement.style.color = '';
            handleTextInputSubmission(inputValue, question.formField);
          } else {
            // Show error and make it red
            errorElement.style.display = 'block';
            errorElement.style.color = 'red';
          }
        });
          
        // Also add input event listener to remove red when user starts typing valid input
        textInput.addEventListener('input', function() {
          const inputValue = textInput.value;
          const isValid = question.validation(inputValue);
          const errorElement = document.getElementById(`${question.formField}-error`);
          
          if (isValid && errorElement.style.display === 'block') {
            // Remove red color if input becomes valid while error is showing
            errorElement.style.color = '';
          }
        });
        
        textInputContainer.appendChild(submitButton);
        messageDiv.appendChild(textInputContainer);
      } else {
        // Add multiple choice options
        const optionsDiv = document.createElement('div');
        optionsDiv.classList.add('chat-input-options-inline');
        
        question.options.forEach(option => {
          const button = document.createElement('button');
          button.classList.add('chat-option-btn-inline');
          button.setAttribute('data-value', option.value);
          button.innerHTML = `<span class="chat-option-btn-inline--icon">${clmIcons.hasOwnProperty(option.icon) ? clmIcons[option.icon] : 'Missing icon: ' + option.icon}</span> ${option.value}`;
            
          // Explicit state reset to prevent inherited hover/selected states
          button.style.backgroundColor = 'transparent';
          button.style.borderColor = '';
          button.blur(); // Remove any focus state
            
          // Add click event
          button.addEventListener('click', function() {
            const selectedValue = this.getAttribute('data-value');
            this.classList.add('selected');
            handleOptionSelection(selectedValue, question.formField);
          });
        
          optionsDiv.appendChild(button);
        });
        
        messageDiv.appendChild(optionsDiv);
      }
    
      chatMessages.appendChild(messageDiv);
      scrollToBottom();
    
      // Auto-focus text input if applicable
      if (question.type === "text" || question.type === "email" || question.type === "tel") {
          setTimeout(() => {
              document.getElementById(`${question.formField}-input`).focus();
          }, 100);
      }
      
    } else {
      // All questions have been answered
      showAIChatOption();
    }
  }
  // Handle text input submission
  function handleTextInputSubmission(value, formField) {
    // Store the answer
    formData[formField] = value;
    
    // Save outgoing message to history
    saveChatHistory({
      type: 'outgoing',
      text: value
    });

    // Disable text input in the last message
    const lastMessage = chatMessages.lastElementChild.previousElementSibling;
    if (lastMessage) {
      const textInput = lastMessage.querySelector('.text-input-field');
      const submitButton = lastMessage.querySelector('.text-input-submit');
        
      if (textInput && submitButton) {
        textInput.disabled = true;
        submitButton.disabled = true;
        submitButton.classList.add('disabled');
      }
    }
    
    // Move to the next question
    currentQuestion++;
    
    // Save current state
    saveChatState();
    
    // Add a small delay before showing next question
    setTimeout(() => {
      showNextQuestion();
    }, 800);
  }

  // Handle option selection
  function handleOptionSelection(value, formField) {
    // Store the answer
    formData[formField] = value;
    
    // Create outgoing message with the selection
    createOutgoingMessage(value);
      
    // Save outgoing message to history
    saveChatHistory({
      type: 'outgoing',
      text: value
    });
    
    // Disable all option buttons in the last message
    const lastMessage = chatMessages.lastElementChild.previousElementSibling;
    if (lastMessage) {
      const buttons = lastMessage.querySelectorAll('.chat-option-btn-inline');
      buttons.forEach(button => {
          button.disabled = true;
          button.classList.add('disabled');
      });
    }
    
    // Move to the next question
    currentQuestion++;
  
    // Save current state
    saveChatState();
    
    // Add a small delay before showing next question
    setTimeout(() => {
      showNextQuestion();
    }, 800);
  }

  // Show AI chat option
  function showAIChatOption() {
    // Mark questions as completed since all 8 questions have been answered
    markQuestionsCompleted();
    
    // Create a message thanking user for completing the form
    createIncomingMessageWithHistory("Thank you for providing this information about your injury case.");
  
    // Ask if they'd like to continue with AI chat
    setTimeout(() => {
      const messageDiv = document.createElement('div');
      messageDiv.classList.add('message', 'incoming');
      messageDiv.textContent = "Would you like to chat with our AI assistant to provide more details about your case?";
    
      // Add Yes/No options
      const optionsDiv = document.createElement('div');
      optionsDiv.classList.add('chat-input-options-inline');
    
      // Yes button
      const yesButton = document.createElement('button');
      yesButton.classList.add('chat-option-btn-inline');
      const chatIcon = clmIcons && clmIcons.hasOwnProperty('chat') ? clmIcons['chat'] : 'Missing icon: chat';
      yesButton.innerHTML = `<span class="chat-option-btn-inline--icon">${chatIcon}</span> Yes, I want to chat`;
      yesButton.addEventListener('click', function() {
        handleChatOptionSelection(true);
      });
      optionsDiv.appendChild(yesButton);
    
      // No button
      const noButton = document.createElement('button');
      noButton.classList.add('chat-option-btn-inline');
      const sendIcon = clmIcons && clmIcons.hasOwnProperty('send') ? clmIcons['send'] : 'Missing icon: send';
      noButton.innerHTML = `<span class="chat-option-btn-inline--icon">${sendIcon}</span> No, submit my information`;
      noButton.addEventListener('click', function() {
        handleChatOptionSelection(false);
      });
      optionsDiv.appendChild(noButton);
    
      messageDiv.appendChild(optionsDiv);
      chatMessages.appendChild(messageDiv);
      scrollToBottom();
    }, 1000);
  }

  // Handle chat option selection
  function handleChatOptionSelection(wantToChat) {
    // Create outgoing message with the selection
    createOutgoingMessage(wantToChat ? "Yes, I want to chat" : "No, submit my information");
    
    // Save outgoing message to history
    saveChatHistory({
      type: 'outgoing',
      text: wantToChat ? "Yes, I want to chat" : "No, submit my information"
    });
    
    // Disable the buttons
    const lastMessage = chatMessages.lastElementChild.previousElementSibling;
    if (lastMessage) {
      const buttons = lastMessage.querySelectorAll('.chat-option-btn-inline');
      buttons.forEach(button => {
        button.disabled = true;
        button.classList.add('disabled');
      });
    }
    
    // If user wants to chat, show the chat input
    if (wantToChat) {
    showChatInput();
    }
    
    // Save current state
    saveChatState();
  
    // Send the form data to the server
    submitFormData(wantToChat);
  }

  // Submit form data to server
  function submitFormData(wantToChat) {
    // Show typing indicator
    showTypingIndicator();
    // Ensure we have a session ID for this request
    initializeSessionId();
    // Create form data for submission
    const submissionData = new FormData();
    // Add form field values
    for (const [key, value] of Object.entries(formData)) {
      submissionData.append(key, value);
    }

    // Add a field indicating whether user wants to chat
    submissionData.append('wantToChat', wantToChat ? 'yes' : 'no');

    // Send to server with X-Session-ID header
    fetch(API_ENDPOINT, {
      method: 'POST',
      body: submissionData,
      headers: {
        'X-Session-ID': sessionId
      }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Server returned error');
        }
        return response.json();
    })
    .then(data => {
      hideTypingIndicator();
      // STEP 2: Save returned sessionId (first time this will be set)
      if (data && data.sessionId) {
        setSessionId(data.sessionId);
      }
      if (wantToChat) {
        // User wants to chat, show chat input
        createIncomingMessageWithHistory(data.message || "Great! I'm here to help gather more details about your case. What additional information would you like to share?");
        showChatForm();
      } else {
        // User doesn't want to chat, show thank you message
        createIncomingMessageWithHistory("Thank you for providing your information. A legal professional will review your case and contact you soon.");
        showCompletionMessage();
      }
    })
    .catch(error => {
        hideTypingIndicator();
        createErrorMessage();
    });
  }



  // Handle chat form submission for follow-up conversation
  if (chatForm) {
    chatForm.addEventListener('submit', function(event) {
      event.preventDefault();
      const message = chatInput.value.trim();
      if (!message) return;
      // Clear input immediately and reset height
      chatInput.value = '';
      chatInput.style.height = 'auto';
      // Create outgoing message
      createOutgoingMessage(message);
      // Save outgoing message to history
      saveChatHistory({
        type: 'outgoing',
        text: message
      });
      // Show typing indicator
      showTypingIndicator();
      // Disable input while waiting
      disableInput();
      // Send message to server with retry logic
      sendMessageWithRetry(message)
        .then(response => {
          // Handle response
          hideTypingIndicator();
          createIncomingMessage(response.message);
          // Save incoming message to history
          saveChatHistory({
              type: 'incoming',
              text: response.message
          });
          // Check if conversation complete
          if (response.conversationComplete) {
              handleConversationComplete();
          } else {
              // Re-enable input
              enableInput();
          }
        })
        .catch(error => {
          // Handle error
          hideTypingIndicator();
          createErrorMessage();
          enableInput();
        });
    });
  }

  // Helper Functions

  // Show the chat form
  function showChatForm() {
    if (chatForm) {
      chatForm.classList.remove('hidden');
      chatForm.style.display = 'flex';
    }

    if ( sendButton ) {
      sendButton.disabled = false;
    }

    if ( chatInput ) {
      chatInput.disabled = false;
      chatInput.placeholder = 'Your message here...';
      chatInput.focus();
    }
  }

  // Show completion message
  function showCompletionMessage() {
    if (completeMessage) {
      completeMessage.classList.remove('hidden');
      completeMessage.style.display = 'block';
    }
  }

  // Show typing indicator
  function showTypingIndicator() {
    // Add aria-live for screen readers
    typingIndicator.setAttribute('aria-live', 'polite');
    typingIndicator.setAttribute('aria-atomic', 'true');
    
    chatMessages.appendChild(typingIndicator);
    scrollToBottom();
    
    // Update chat status region for screen readers
    const chatStatus = document.getElementById('chat-status');
    if (chatStatus) {
      chatStatus.textContent = 'Sofia is typing a response';
    }
  }

  // Hide typing indicator
  function hideTypingIndicator() {
    if (typingIndicator.parentNode === chatMessages) {
      chatMessages.removeChild(typingIndicator);
    }
      
    // Clear chat status region
    const chatStatus = document.getElementById('chat-status');
    if (chatStatus) {
      chatStatus.textContent = '';
    }
  }

  // Create outgoing message bubble
  function createOutgoingMessage(message) {
    const messageDiv = document.createElement('div');
    messageDiv.classList.add('message', 'outgoing', 'message--sending');
    messageDiv.textContent = message;
      
    // Add timestamp for when message is sent
    const now = new Date();
    const timestamp = now.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true 
    });
    messageDiv.setAttribute('data-timestamp', timestamp);
      
    chatMessages.appendChild(messageDiv);
    scrollToBottom();
      
    // Remove sending state after a short delay to show the loading effect
    setTimeout(() => {
      messageDiv.classList.remove('message--sending');
      messageDiv.classList.add('message--sent');
    }, 300);
  }

  // Create incoming message bubble
  function createIncomingMessage(message) {
    const messageDiv = document.createElement('div');
    messageDiv.classList.add('message', 'incoming');
    messageDiv.textContent = message;
    chatMessages.appendChild(messageDiv);
    scrollToBottom();
  }

  // Create error message
  function createErrorMessage() {
    const errorDiv = document.createElement('div');
    errorDiv.classList.add('message', 'system', 'error');
    const errorIcon = clmIcons && clmIcons.hasOwnProperty('error') ? clmIcons['error'] : '⚠️';
    errorDiv.innerHTML = `<span class="chat-option-btn-inline--icon">${errorIcon}</span> Sorry, there was an error processing your request. Please try again.`;
    chatMessages.appendChild(errorDiv);
    scrollToBottom();
  }

  // Disable input during processing
  function disableInput() {
    chatForm.classList.add('waiting');
    chatForm.classList.add('chat-input--sending');
    chatInput.disabled = true;
    sendButton.disabled = true;
    
      // Update send button status for screen readers
    const buttonStatus = document.getElementById('send-button-status');
    if (buttonStatus) {
      buttonStatus.textContent = 'Sending message, please wait...';
    }
    
    // Update chat status region
    const chatStatus = document.getElementById('chat-status');
    if (chatStatus) {
      chatStatus.textContent = 'Sending your message to Sofia';
    }
  }

  // Enable input after processing
  function enableInput() {
    chatForm.classList.remove('waiting');
    chatForm.classList.remove('chat-input--sending');
    chatInput.disabled = false;
    sendButton.disabled = false;
    chatInput.focus();
      
    // Clear send button status
    const buttonStatus = document.getElementById('send-button-status');
    if (buttonStatus) {
      buttonStatus.textContent = '';
    }
      
    // Clear chat status region
    const chatStatus = document.getElementById('chat-status');
    if (chatStatus) {
      chatStatus.textContent = '';
    }
  }

  // Handle conversation completion
  function handleConversationComplete() {
    // Mark conversation as completed (use existing flag for both scenarios)
    markConversationCompleted();
    
    // STEP 3: Clear session so a new conversation starts next time
    clearSessionId();

    // Disable form after completion for both chat and submission
    if (chatForm) {
      chatForm.classList.add('disabled');
      chatInput.disabled = true;
      sendButton.disabled = true;
      chatInput.placeholder = 'Chat completed';
      // Hide the entire form for completed conversations
      chatForm.style.display = 'none';
    }

    // Show completion message
    showCompletionMessage();

    // Add a completion message
    const systemMsg = document.createElement('div');
    systemMsg.classList.add('message', 'system');
    const completionIcon = clmIcons && clmIcons.hasOwnProperty('check_circle') ? clmIcons['check_circle'] : '✓';
    systemMsg.innerHTML = `<span class="chat-option-btn-inline--icon">${completionIcon}</span> Thank you for providing all the necessary information.`;
    chatMessages.appendChild(systemMsg);
    
    // Add Start Over button for completed conversations
    addStartOverButton();
    
    scrollToBottom();
  }
  
  // Show completed state when page loads after completion
  function showCompletedState(addStartOver = false, savedState = null, savedHistory = null) {
    // Clear any existing messages
    chatMessages.innerHTML = '';
    
    // Determine completion type by analyzing chat history
    const completionType = getConversationCompletionType();
    
    // If we have saved history and state, restore it first
    if (savedState && savedHistory && savedHistory.length > 0) {
      // Restore form data and current question
      Object.assign(formData, savedState.formData);
      currentQuestion = savedState.currentQuestion;
      if (savedState.sessionId) {
        setSessionId(savedState.sessionId);
      }
        
      // Restore all previous questions and answers
      for (let i = 0; i < questions.length && i < savedState.currentQuestion; i++) {
        const question = questions[i];
        const answer = savedState.formData[question.formField];
        
        // Create question message
        const messageDiv = document.createElement('div');
        messageDiv.classList.add('message', 'incoming');
        
        const questionTextDiv = document.createElement('div');
        questionTextDiv.textContent = `${question.text} (${i + 1}/${totalQuestions})`;
        messageDiv.appendChild(questionTextDiv);
            
        // Add options if it's a multiple choice question
        if (question.options) {
          const optionsDiv = document.createElement('div');
          optionsDiv.classList.add('chat-input-options-inline');
          
          question.options.forEach(option => {
            const optionButton = document.createElement('button');
            optionButton.classList.add('chat-option-btn-inline');
            optionButton.innerHTML = `<span class="chat-option-btn-inline--icon">${clmIcons.hasOwnProperty(option.icon) ? clmIcons[option.icon] : 'Missing icon: ' + option.icon}</span> ${option.value}`;
                    
            // Highlight the selected answer and disable all options
            if (answer === option.value) {
              optionButton.classList.add('selected');
            }
                    
            // Disable all options
            optionButton.disabled = true;
            optionButton.classList.add('disabled');
            
            optionsDiv.appendChild(optionButton);
          });
                
          messageDiv.appendChild(optionsDiv);
        }
            
        chatMessages.appendChild(messageDiv);
        
        // For text input questions, show the user's answer as an outgoing message
        if (question.type === "text" || question.type === "email" || question.type === "tel") {
          if (answer && answer.trim() !== "") {
            const answerDiv = document.createElement('div');
            answerDiv.classList.add('message', 'outgoing');
            answerDiv.textContent = answer;
            chatMessages.appendChild(answerDiv);
          }
        }
      }
      
      // Handle different completion types
      if (completionType === 'submission') {
        // Show the AI chat option question with "No" pre-selected
        const messageDiv = document.createElement('div');
        messageDiv.classList.add('message', 'incoming');
        messageDiv.textContent = "Would you like to chat with our AI assistant to provide more details about your case?";
    
        // Add Yes/No options
        const optionsDiv = document.createElement('div');
        optionsDiv.classList.add('chat-input-options-inline');
    
        // Yes button
        const yesButton = document.createElement('button');
        yesButton.classList.add('chat-option-btn-inline');
        yesButton.innerHTML = `<span class="chat-option-btn-inline--icon">${clmIcons.hasOwnProperty('chat') ? clmIcons['chat'] : 'Missing icon: ' + 'chat'}</span> Yes, I want to chat`;
        yesButton.disabled = true;
        yesButton.classList.add('disabled');
        optionsDiv.appendChild(yesButton);
    
        // No button (pre-selected)
        const noButton = document.createElement('button');
        noButton.classList.add('chat-option-btn-inline', 'selected');
        noButton.innerHTML = `<span class="chat-option-btn-inline--icon">${clmIcons.hasOwnProperty('send') ? clmIcons['send'] : 'Missing icon: ' + 'send'}</span> No, submit my information`;
        noButton.disabled = true;
        noButton.classList.add('disabled');
        optionsDiv.appendChild(noButton);
    
        messageDiv.appendChild(optionsDiv);
        chatMessages.appendChild(messageDiv);
        
        // Add the user's selection message
        const selectionDiv = document.createElement('div');
        selectionDiv.classList.add('message', 'outgoing');
        selectionDiv.textContent = "No, submit my information";
        chatMessages.appendChild(selectionDiv);
        
        // Add the thank you message
        const thankYouDiv = document.createElement('div');
        thankYouDiv.classList.add('message', 'incoming');
        thankYouDiv.textContent = "Thank you for providing your information. A legal professional will review your case and contact you soon.";
        chatMessages.appendChild(thankYouDiv);
        
      } else if (completionType === 'chat') {
        // Show chat history for completed chat conversations
        savedHistory.forEach(msg => {
          const messageDiv = document.createElement('div');
          messageDiv.classList.add('message', msg.type);
          
          if (msg.type === 'incoming') {
            messageDiv.textContent = msg.text;
          } else if (msg.type === 'outgoing') {
            messageDiv.textContent = msg.text;
            const timestamp = new Date(msg.timestamp).toLocaleTimeString('en-US', { 
              hour: 'numeric', 
              minute: '2-digit',
              hour12: true 
            });
            messageDiv.setAttribute('data-timestamp', timestamp);
          }
          
          chatMessages.appendChild(messageDiv);
        });
      }
    }
      
    // Add "Thank you for providing all the necessary information." message BELOW the most recent message
    const systemMsg = document.createElement('div');
    systemMsg.classList.add('message', 'system');
    const completionIcon = clmIcons && clmIcons.hasOwnProperty('check_circle') ? clmIcons['check_circle'] : 'â';
    systemMsg.innerHTML = `<div style="display: flex; align-items: center; gap: 8px;"><span class="chat-option-btn-inline--icon">${completionIcon}</span><span>Thank you for providing all the necessary information.</span></div>`;
    chatMessages.appendChild(systemMsg);
      
    // Add "Start Over" button BELOW the "Thank you..." section
    if (addStartOver) {
      addStartOverButton();
    }
      
    // Disable and hide the chat form for completed conversations
    if (chatForm) {
      chatForm.classList.add('disabled', 'completed');
      chatInput.disabled = true;
      sendButton.disabled = true;
      chatInput.placeholder = 'Chat completed';
      // Hide the entire form for completed conversations
      chatForm.style.display = 'none';
    }
    
    // Handle mobile input visibility for completed conversations
    if (isMobile) {
      hideChatInput();
    }
      
    scrollToBottom();
  }

  // Show chat input on mobile
  function showChatInput() {
    if (chatForm) {
      chatForm.classList.add('chat-mode-active');
      document.body.classList.add('chat-input-active');
      chatInput.disabled = false;
      sendButton.disabled = false;
      chatInput.placeholder = 'Your message here...';
          
      // Focus input after a short delay to allow for animation
      setTimeout(() => {
        chatInput.focus();
      }, 300);
    }
  }

  // Hide chat input on mobile
  function hideChatInput() {
    if (chatForm) {
      chatForm.classList.remove('chat-mode-active');
      document.body.classList.remove('chat-input-active');
      chatInput.disabled = true;
      sendButton.disabled = true;
      chatInput.placeholder = 'Chat unavailable right now';
    }
  }

  // Mobile debugging tools for Safari keyboard positioning
  function createMobileDebugOverlay() {
    if (window.innerWidth > 767) return; // Only on mobile
      
    // Create debug overlay with positioning relative to visual viewport
    const debugOverlay = document.createElement('div');
    debugOverlay.id = 'mobile-debug-overlay';
    debugOverlay.style.cssText = `
        position: fixed;
          top: 10px;
          right: 10px;
          background: rgba(0, 0, 0, 0.95);
          color: white;
          padding: 15px;
          border-radius: 8px;
          font-size: 11px;
          font-family: monospace;
          z-index: 999999;
          max-width: 280px;
          line-height: 1.3;
          box-shadow: 0 4px 12px rgba(0,0,0,0.3);
          transform: translateZ(0);
          -webkit-transform: translateZ(0);
          will-change: transform;
    `;
    
    // Add version detection
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const iosVersion = isIOS ? navigator.userAgent.match(/OS (\d+_\d+)/i)?.[1]?.replace('_', '.') : 'Unknown';
    const safariVersion = isSafari ? navigator.userAgent.match(/Version\/(\d+\.\d+)/i)?.[1] : 'Unknown';
      
      debugOverlay.innerHTML = `
          <div style="margin-bottom: 8px; font-weight: bold; color: #4CAF50;">
              📱 Mobile Debug Panel
          </div>
          <div><strong>Browser:</strong> ${isSafari ? 'Safari' : 'Other'}</div>
          <div><strong>iOS:</strong> ${iosVersion}</div>
          <div><strong>Safari:</strong> ${safariVersion}</div>
          <div><strong>Screen:</strong> ${window.innerWidth}x${window.innerHeight}</div>
          <div id="debug-vv-height"><strong>VV Height:</strong> --px</div>
          <div id="debug-keyboard-height"><strong>Keyboard:</strong> --px</div>
          <div id="debug-chat-height"><strong>Chat Height:</strong> --px</div>
          <div id="debug-body-scroll"><strong>Body Scroll:</strong> --</div>
          <div id="debug-gap"><strong>Gap:</strong> --px</div>
          <div style="margin-top: 8px;">
              <button onclick="toggleDebugIndicators()" style="background: #2196F3; color: white; border: none; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 10px;">
                  Toggle Visual Indicators
              </button>
          </div>
          <div style="margin-top: 4px;">
              <button onclick="toggleDebugPosition()" style="background: #ff9800; color: white; border: none; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 10px;">
                  Toggle Position
              </button>
          </div>
      `;
      
    // Add to document element instead of body to avoid body positioning issues
    document.documentElement.appendChild(debugOverlay);
    
    // Update debug info continuously
    setInterval(updateDebugInfo, 100);
  }
  
  function toggleDebugPosition() {
    const debugOverlay = document.getElementById('mobile-debug-overlay');
    if (!debugOverlay) return;
    
    const currentTop = debugOverlay.style.top;
    if (currentTop === '10px') {
      debugOverlay.style.top = 'auto';
      debugOverlay.style.bottom = '10px';
    } else {
      debugOverlay.style.top = '10px';
      debugOverlay.style.bottom = 'auto';
    }
  }
  
  function updateDebugInfo() {
    // Use consistent visual viewport height for keyboard calculation
    const vvHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    // Use initial inner height stored when keyboard handling started
    const initialHeight = window.initialInnerHeight || window.innerHeight;
    const keyboardHeight = initialHeight - vvHeight;
    
    const debugVV = document.getElementById('debug-vv-height');
    const debugKB = document.getElementById('debug-keyboard-height');
    const debugCH = document.getElementById('debug-chat-height');
    const debugBS = document.getElementById('debug-body-scroll');
    const debugGap = document.getElementById('debug-gap');
    
    if (debugVV) debugVV.innerHTML = `<strong>VV Height:</strong> ${vvHeight}px`;
    if (debugKB) debugKB.innerHTML = `<strong>Keyboard:</strong> ${Math.max(0, keyboardHeight)}px`;
    if (debugCH) {
      const chatContainer = document.querySelector('.site-messages__container');
      const chatHeight = chatContainer ? chatContainer.offsetHeight : 0;
      debugCH.innerHTML = `<strong>Chat Height:</strong> ${chatHeight}px`;
    }
    if (debugBS) {
      const bodyStyle = window.getComputedStyle(document.body);
      const isFixed = bodyStyle.position === 'fixed';
      const isOverflowHidden = bodyStyle.overflow === 'hidden';
      debugBS.innerHTML = `<strong>Body Scroll:</strong> <span style="color: ${isFixed && isOverflowHidden ? '#4CAF50' : '#ff9800'}">${isFixed ? 'Fixed' : 'Auto'}</span>`;
    }
    if (debugGap) {
      const chatInput = document.querySelector('.chat-input');
      const gap = calculateChatGap();
      debugGap.innerHTML = `<strong>Gap:</strong> <span style="color: ${gap > 0 ? '#ff9800' : '#4CAF50'}">${gap}px</span>`;
    }
  }
  
  function calculateChatGap() {
    const chatInput = document.querySelector('.chat-input');
    const vvHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    
    if (!chatInput || !window.visualViewport) return 0;
    
    // Use visual viewport coordinates for accurate gap measurement
    const chatRect = chatInput.getBoundingClientRect();
    const chatBottom = chatRect.bottom;
    const viewportBottom = vvHeight;
    
    // Calculate gap: positive means chat is below viewport (too high)
    const gap = chatBottom - viewportBottom;
    return Math.max(0, Math.round(gap));
  }
  
  function toggleDebugIndicators() {
    const existing = document.getElementById('debug-indicators');
    if (existing) {
      existing.remove();
    } else {
      createDebugIndicators();
    }
  }
  
  function createDebugIndicators() {
    const indicators = document.createElement('div');
    indicators.id = 'debug-indicators';
    indicators.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 9999;
    `;
      
    const vvHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    
    // Red line: Where keyboard top should be
    const keyboardLine = document.createElement('div');
    keyboardLine.style.cssText = `
        position: absolute;
        bottom: ${vvHeight}px;
        left: 0;
        width: 100%;
        height: 2px;
        background: #ff0000;
    `;
    keyboardLine.innerHTML = '<div style="position: absolute; right: 10px; top: -20px; background: #ff0000; color: white; padding: 2px 6px; font-size: 10px; border-radius: 2px;">Keyboard Top</div>';
      
    // Blue line: Where chat input actually is
    const chatInput = document.querySelector('.chat-input');
    let chatBottom = 0;
    if (chatInput) {
      chatBottom = chatInput.getBoundingClientRect().bottom;
      const chatLine = document.createElement('div');
      chatLine.style.cssText = `
          position: absolute;
          bottom: ${chatBottom}px;
          left: 0;
          width: 100%;
          height: 2px;
          background: #2196F3;
      `;
      chatLine.innerHTML = '<div style="position: absolute; right: 10px; top: -20px; background: #2196F3; color: white; padding: 2px 6px; font-size: 10px; border-radius: 2px;">Chat Bottom</div>';
      indicators.appendChild(chatLine);
    }
      
    indicators.appendChild(keyboardLine);
    document.body.appendChild(indicators);
  }
  
  // Initialize debug tools on mobile (disabled)
  function initMobileDebugTools() {
    // Debug tools disabled for now
    return;
  }

  // Send message to server with retry logic
  async function sendMessageWithRetry(message, maxRetries = 2) {
    let lastError;
      
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
      try {
        const response = await sendMessageToServer(message);
        return response;
      } catch (error) {
        lastError = error;
        // Continue to next retry if not the last attempt
        if (attempt < maxRetries) {
          continue;
        }
      }
    }
      
    // All retries failed, throw the last error
    throw lastError;
  }

  // Send message to server
  async function sendMessageToServer(message) {
    try {
      // Ensure we have a session ID for this request
      initializeSessionId();

      // Create form data
      const msgFormData = new FormData();
      msgFormData.append('message', message);

      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        body: msgFormData,
        headers: {
          'X-Session-ID': sessionId
        }
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      // Parse the JSON response
      const jsonResponse = await response.json();

      // STEP 3: Update stored sessionId if backend sends one
      if (jsonResponse && jsonResponse.sessionId) {
        setSessionId(jsonResponse.sessionId);
      }

      return {
        message: jsonResponse.message,
        conversationComplete: jsonResponse.conversationComplete,
        sessionId: jsonResponse.sessionId,
        clientProfile: jsonResponse.clientProfile
      };
    } catch (error) {
        throw error;
    }
  }

  // Helper function to scroll chat to bottom
  function scrollToBottom() {
    chatMessages.scrollTop = chatMessages.scrollHeight;
  }

  startConversation();
});

function debounce(func){
  var timer;
  return function(event){
    if(timer) clearTimeout(timer);
    timer = setTimeout(func,100,event);
  };
}


